/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Map: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type AiUsage = {
  __typename?: 'AIUsage';
  lastLogDate?: Maybe<Scalars['String']['output']>;
  savedVsSpent: Array<AiUsageTimeSeriesItem>;
  shouldShowTimeToLogUsageDialog: Scalars['Boolean']['output'];
  timeSaved: Array<AiUsageTimeSeriesItem>;
  timeSpent: Array<AiUsageTimeSeriesItem>;
};

export type AiUsageTimeSeriesItem = {
  __typename?: 'AIUsageTimeSeriesItem';
  entryType: TimeEntryType;
  monthSince: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type Achievement = {
  __typename?: 'Achievement';
  achievementID: Scalars['String']['output'];
  awardedOn?: Maybe<Scalars['String']['output']>;
  iconURL: Scalars['String']['output'];
  id: Scalars['String']['output'];
  objective?: Maybe<LearningObjective>;
  progress: Scalars['Float']['output'];
  shareImage?: Maybe<Scalars['String']['output']>;
  shareURL?: Maybe<Scalars['String']['output']>;
  target: Scalars['Float']['output'];
};

export type AchievementListResponse = {
  __typename?: 'AchievementListResponse';
  achievements: Array<Achievement>;
};

export type AddResourceFromFileInput = {
  fileID: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  libraryID?: InputMaybe<Scalars['ID']['input']>;
  urgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgendaItem = {
  __typename?: 'AgendaItem';
  description?: Maybe<Scalars['String']['output']>;
  endDatetime: Scalars['String']['output'];
  recording?: Maybe<Resource>;
  speaker?: Maybe<Profile>;
  startDatetime: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiPersonalizerCompletionResponse = {
  __typename?: 'AiPersonalizerCompletionResponse';
  potentialUseCase?: Maybe<Array<UseCase>>;
  userRoleContextLong: Scalars['String']['output'];
  userRoleContextShort: Scalars['String']['output'];
};

export type AiPersonalizerResponse = {
  __typename?: 'AiPersonalizerResponse';
  completionResponse?: Maybe<AiPersonalizerCompletionResponse>;
  message: AiMessage;
  threadID: Scalars['ID']['output'];
};

export type AiUseCase = {
  __typename?: 'AiUseCase';
  description: Scalars['String']['output'];
  impactRating: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AiUseCaseFinderResponse = {
  __typename?: 'AiUseCaseFinderResponse';
  potentialUseCase?: Maybe<Array<AiUseCase>>;
};

export type AnnotationComment = {
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  profile: Profile;
  resource: Resource;
};

export type AnnotationHighlight = {
  canEdit: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  comments: Array<AnnotationHighlightComment>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  privateNote?: Maybe<AnnotationHighlightComment>;
  profile: Profile;
  resource: Resource;
  suffix: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type AnnotationHighlightComment = {
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt: Scalars['String']['output'];
  highlight: AnnotationHighlight;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  profile: Profile;
  resource: Resource;
};

export type Annotations = {
  __typename?: 'Annotations';
  comments: Array<ResourceComment>;
  highlights: Array<AnnotationHighlight>;
};

export type AnnouncementPost = {
  __typename?: 'AnnouncementPost';
  date: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AuthenticateInput = {
  authorizationCode: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  utm?: InputMaybe<UtmParams>;
};

export type AuthenticateResponse = {
  __typename?: 'AuthenticateResponse';
  accessToken: Scalars['String']['output'];
  newUser: Scalars['Boolean']['output'];
  refreshToken: Scalars['String']['output'];
};

export type Badge = {
  __typename?: 'Badge';
  assessment?: Maybe<BadgeAssessment>;
  metadata: BadgeMetadata;
  progress?: Maybe<BadgeProgress>;
};

export type BadgeAssessment = {
  __typename?: 'BadgeAssessment';
  available: Scalars['Boolean']['output'];
  awardedOn?: Maybe<Scalars['String']['output']>;
  badgeAssessmentState: BadgeAssessmentState;
  grantId?: Maybe<Scalars['ID']['output']>;
  shareImage?: Maybe<Scalars['String']['output']>;
  shareURL?: Maybe<Scalars['String']['output']>;
  targetPromptLevel?: Maybe<Scalars['Int']['output']>;
};

export enum BadgeAssessmentState {
  Available = 'available',
  Done = 'done',
  HasNotDoneAllDays = 'hasNotDoneAllDays',
  HasNotHitTarget = 'hasNotHitTarget',
  HasNotPromptLevel = 'hasNotPromptLevel',
  Unavailable = 'unavailable'
}

export type BadgeMetadata = {
  __typename?: 'BadgeMetadata';
  id: Scalars['ID']['output'];
  imageURL: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BadgeProgress = {
  __typename?: 'BadgeProgress';
  current: Scalars['Int']['output'];
  percent: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
};

export enum BillingRecurrence {
  Month = 'month',
  Year = 'year'
}

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  stripePaymentLink: Scalars['String']['output'];
};

export type BillingUser = {
  __typename?: 'BillingUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type Caption = {
  __typename?: 'Caption';
  caption: Array<Maybe<CaptionElement>>;
  state: Scalars['String']['output'];
};

export type CaptionElement = {
  __typename?: 'CaptionElement';
  duration: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
  text: Scalars['String']['output'];
};

export type Cohort = {
  __typename?: 'Cohort';
  badges: Array<Badge>;
  context: Scalars['String']['output'];
  demoSubmissions?: Maybe<DemoSubmissionList>;
  enrolled: Scalars['Boolean']['output'];
  events: Array<MindspaceEvent>;
  firstIncompleteItem?: Maybe<SectionItem>;
  id: Scalars['ID']['output'];
  leaderboard?: Maybe<Leaderboard>;
  metadata: CohortMetadata;
  name: Scalars['String']['output'];
  pearsonCode?: Maybe<Scalars['String']['output']>;
  pearsonCodeExpiry?: Maybe<Scalars['String']['output']>;
  preRegistrations?: Maybe<PreRegistrationList>;
  proTip?: Maybe<ProTip>;
  programID?: Maybe<Scalars['ID']['output']>;
  progress: Scalars['Int']['output'];
  progressReport?: Maybe<ProgressReport>;
  progressReportUseCasesDemosSummaries?: Maybe<ProgressReportUseCasesDemosSummaries>;
  section: Section;
  sections: Array<Section>;
  selectedPersonalization?: Maybe<UseCase>;
  useCases: UseCaseList;
};


export type CohortDemoSubmissionsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Sort>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type CohortLeaderboardArgs = {
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  noPromptLevel?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Sort>;
  orderBy?: InputMaybe<LeaderboardOrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
};


export type CohortPreRegistrationsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Sort>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
};


export type CohortSectionArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type CohortUseCasesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type CohortJoin = {
  __typename?: 'CohortJoin';
  appleProductId?: Maybe<Scalars['String']['output']>;
  cohortID: Scalars['String']['output'];
  joined: Scalars['Boolean']['output'];
  mindspaceID: Scalars['String']['output'];
  paymentLinkURL?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Program>;
  seatInvitations: Array<CohortSeatInvitation>;
  seats: Scalars['Int']['output'];
};

export type CohortMetadata = {
  __typename?: 'CohortMetadata';
  endDate?: Maybe<Scalars['String']['output']>;
  price: CohortPrice;
  startDate?: Maybe<Scalars['String']['output']>;
  totalSpots: Scalars['Int']['output'];
  type: CohortType;
};

export type CohortPrice = CohortPriceFree | CohortPriceIncluded | CohortPricePaid;

export type CohortPriceFree = {
  __typename?: 'CohortPriceFree';
  display: Scalars['String']['output'];
  freeSpots?: Maybe<Scalars['Int']['output']>;
};

export type CohortPriceIncluded = {
  __typename?: 'CohortPriceIncluded';
  display: Scalars['String']['output'];
  freeSpots?: Maybe<Scalars['Int']['output']>;
};

export type CohortPricePaid = {
  __typename?: 'CohortPricePaid';
  appleProductId: Scalars['String']['output'];
  billingUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  display: Scalars['String']['output'];
  freeSpots?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
};

export type CohortSeatInvitation = {
  __typename?: 'CohortSeatInvitation';
  email: Scalars['String']['output'];
};

export enum CohortType {
  Live = 'Live',
  SelfServed = 'SelfServed'
}

export type Comment = {
  __typename?: 'Comment';
  authorName: Scalars['String']['output'];
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt: Scalars['String']['output'];
  highlight: Highlight;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  profile: Profile;
  resource: Resource;
  xfdfString?: Maybe<Scalars['String']['output']>;
};

export type CommentInput = {
  content: Scalars['String']['input'];
  xfdfString?: InputMaybe<Scalars['String']['input']>;
};

export type CompletionCriteria = {
  __typename?: 'CompletionCriteria';
  contentComplete: Scalars['Int']['output'];
  evidencePointsMet: Scalars['Int']['output'];
  promptLevelMet: Scalars['Int']['output'];
};

export type Config = {
  __typename?: 'Config';
  api: Scalars['String']['output'];
  appUrl: Scalars['String']['output'];
  communityUrl: Scalars['String']['output'];
  environment: Environment;
  extension: ExtensionConfig;
  googleMapKey: Scalars['String']['output'];
  graphql: Scalars['String']['output'];
  growthbookKey: Scalars['String']['output'];
  identityUrl: Scalars['String']['output'];
  oauth?: Maybe<OAuthConfig>;
  pearsonExamUrl: Scalars['String']['output'];
  pearsonHelpArticleUrl: Scalars['String']['output'];
  rudderstack?: Maybe<RudderstackConfig>;
  rudderstackURL: Scalars['String']['output'];
  siteURL: Scalars['String']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
};

export type CopyResourceToLibraryInput = {
  asResource?: InputMaybe<Scalars['Boolean']['input']>;
  copyAnnotations: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  libraryID: Scalars['ID']['input'];
  shareReason?: InputMaybe<Scalars['String']['input']>;
};

export type Counters = {
  __typename?: 'Counters';
  comments: Scalars['Int']['output'];
  highlights: Scalars['Int']['output'];
};

export type CreateLibraryInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  aiUsage: AiUsage;
  billing?: Maybe<UserBilling>;
  email: Scalars['String']['output'];
  hasAddedResources: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isStaff: Scalars['Boolean']['output'];
  nps?: Maybe<Array<NpsScore>>;
  preferences: Preferences;
  referrals: Array<Referrals>;
};

export type DemoSubmissionInput = {
  demoType: DemoType;
  description: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  recordingFileId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type DemoSubmissionList = {
  __typename?: 'DemoSubmissionList';
  hasUserSubmittedDemo: Scalars['Boolean']['output'];
  items: Array<SectionItemContentDemoSubmission>;
  totalCount: Scalars['Int']['output'];
};

export type DemoSubmitter = {
  __typename?: 'DemoSubmitter';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum DemoType {
  Live = 'LIVE',
  Recording = 'RECORDING'
}

export type EditLibraryDescriptionInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export enum Environment {
  Development = 'development',
  Production = 'production',
  S101 = 's101'
}

export type EventAttendance = {
  __typename?: 'EventAttendance';
  attendees: ProfileListResponse;
  available?: Maybe<Scalars['Int']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  registered?: Maybe<Scalars['Int']['output']>;
};


export type EventAttendanceAttendeesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export enum EventFilter {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type EventLocation = GeoLocation | OnlineLocation;

export type EventSponsor = {
  __typename?: 'EventSponsor';
  isPartner: Scalars['Boolean']['output'];
  sponsor: Sponsor;
};

export enum EventState {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type EvidencePointsEarned = {
  __typename?: 'EvidencePointsEarned';
  updatedEvidencePoints: Scalars['Float']['output'];
};

export type Evidencing = {
  __typename?: 'Evidencing';
  comparison?: Maybe<EvidencingComparison>;
  objective?: Maybe<LearningObjective>;
  points?: Maybe<Scalars['Float']['output']>;
};

export type EvidencingComparison = {
  __typename?: 'EvidencingComparison';
  pointsChange: Scalars['Float']['output'];
};

export type EvidencingPassiveDetails = {
  __typename?: 'EvidencingPassiveDetails';
  earnablePoints: Scalars['Float']['output'];
  earnedPoints: Scalars['Float']['output'];
  skill: Skill;
};

export type EvidencingTriviaDetails = {
  __typename?: 'EvidencingTriviaDetails';
  earnablePoints: Scalars['Float']['output'];
  earnedPoints: Scalars['Float']['output'];
  skill: Skill;
};

export type Extension = {
  afterBlockIndex: Scalars['Int']['output'];
};

export type ExtensionConfig = {
  __typename?: 'ExtensionConfig';
  blacklist: Array<Scalars['String']['output']>;
  growthBookKey: Scalars['String']['output'];
  ignoreErrors: Array<Scalars['String']['output']>;
  installRedirectURL: Scalars['String']['output'];
  mixpanelToken: Scalars['String']['output'];
  rudderstackURL: Scalars['String']['output'];
  rudderstackWriteKeyExtension: Scalars['String']['output'];
  sentryDsn: Scalars['String']['output'];
  uninstallRedirectURL: Scalars['String']['output'];
  updateRedirectURL: Scalars['String']['output'];
  updateRedirectVersion: Scalars['String']['output'];
};

export type ExtraDataTuple = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FilePrepareResponse = {
  __typename?: 'FilePrepareResponse';
  fileDisplayUrl: Scalars['String']['output'];
  fileID: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Flow = {
  __typename?: 'Flow';
  item?: Maybe<FlowItem>;
  next?: Maybe<Array<FlowItem>>;
  state: FlowState;
};


export type FlowNextArgs = {
  limit: Scalars['Int']['input'];
};

export type FlowItem = {
  __typename?: 'FlowItem';
  objective?: Maybe<LearningObjective>;
  relevancy: Scalars['String']['output'];
  resource: Resource;
  score: Scalars['Int']['output'];
  suggested: Scalars['Boolean']['output'];
};

export enum FlowState {
  Generating = 'generating',
  NoObjective = 'noObjective',
  Ready = 'ready'
}

export type FullFlow = {
  __typename?: 'FullFlow';
  hasMore: Scalars['Boolean']['output'];
  items: Array<FlowItem>;
  nextItem: Scalars['Int']['output'];
  totalHits: Scalars['Int']['output'];
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  address: Scalars['String']['output'];
};

export type GetAllResourcesResponse = {
  __typename?: 'GetAllResourcesResponse';
  nextItem: Scalars['Int']['output'];
  readingTime: Scalars['Float']['output'];
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type GetAnnouncementsResponse = {
  __typename?: 'GetAnnouncementsResponse';
  hasNew: Scalars['Boolean']['output'];
  posts: Array<AnnouncementPost>;
  url: Scalars['String']['output'];
};

export type GetArchivedResourcesResponse = {
  __typename?: 'GetArchivedResourcesResponse';
  nextItem: Scalars['Int']['output'];
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type GetInboxResourcesResponse = {
  __typename?: 'GetInboxResourcesResponse';
  nextItem: Scalars['Int']['output'];
  readingTime: Scalars['Float']['output'];
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type GetLibrariesResponse = {
  __typename?: 'GetLibrariesResponse';
  libraries: Array<Maybe<Library>>;
};

export type GetLibraryResourcesResponse = {
  __typename?: 'GetLibraryResourcesResponse';
  nextItem: Scalars['Int']['output'];
  readingTime: Scalars['Float']['output'];
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type GetLibraryUsersResponse = {
  __typename?: 'GetLibraryUsersResponse';
  nextItem: Scalars['Int']['output'];
  users: Array<Maybe<User>>;
};

export type GetNotificationsResponse = {
  __typename?: 'GetNotificationsResponse';
  items: Array<Maybe<NotificationItem>>;
  nextToken: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type GetUrgentResourcesResponse = {
  __typename?: 'GetUrgentResourcesResponse';
  nextItem: Scalars['Int']['output'];
  readingTime: Scalars['Float']['output'];
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type GetUserTagsResponse = {
  __typename?: 'GetUserTagsResponse';
  tags: Array<Maybe<Tag>>;
};

export type GoalSettings = {
  __typename?: 'GoalSettings';
  minutes: Scalars['Int']['output'];
  timeOfDay: TimeOfDay;
};

export enum GroupByTime {
  Day = 'DAY',
  Week = 'WEEK'
}

export type HtmlComment = AnnotationComment & AnnotationHighlightComment & {
  __typename?: 'HTMLComment';
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt: Scalars['String']['output'];
  highlight: AnnotationHighlight;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  profile: Profile;
  resource: Resource;
};

export type HtmlHighlight = AnnotationHighlight & {
  __typename?: 'HTMLHighlight';
  canEdit: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  comments: Array<AnnotationHighlightComment>;
  createdAt: Scalars['String']['output'];
  endOffset: Scalars['Int']['output'];
  endParentID: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  privateNote?: Maybe<AnnotationHighlightComment>;
  profile: Profile;
  resource: Resource;
  startOffset: Scalars['Int']['output'];
  startParentID: Scalars['Int']['output'];
  suffix: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type HtmlHighlightInput = {
  color: Scalars['String']['input'];
  endOffset: Scalars['Int']['input'];
  endParentID: Scalars['Int']['input'];
  model: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
  startOffset: Scalars['Int']['input'];
  startParentID: Scalars['Int']['input'];
  suffix: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type Highlight = {
  __typename?: 'Highlight';
  authorName: Scalars['String']['output'];
  canEdit: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  endMatchingText?: Maybe<Scalars['String']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endParentID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  page?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  rememberID?: Maybe<Scalars['String']['output']>;
  resource: Resource;
  startMatchingText?: Maybe<Scalars['String']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startParentID?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  threadID?: Maybe<Scalars['String']['output']>;
  xfdfString?: Maybe<Scalars['String']['output']>;
};

export type HighlightInput = {
  color: Scalars['String']['input'];
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  endParentID?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
  startParentID?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  threadID?: InputMaybe<Scalars['String']['input']>;
  xfdfString?: InputMaybe<Scalars['String']['input']>;
};

export type Highlighter = {
  __typename?: 'Highlighter';
  color: Scalars['String']['output'];
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
};

export type HighlighterInput = {
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
};

export type Highlighters = {
  __typename?: 'Highlighters';
  marker0?: Maybe<Highlighter>;
  marker1?: Maybe<Highlighter>;
  marker2?: Maybe<Highlighter>;
  marker3?: Maybe<Highlighter>;
  marker4?: Maybe<Highlighter>;
  marker5?: Maybe<Highlighter>;
};

export type HighlightersInput = {
  marker0?: InputMaybe<HighlighterInput>;
  marker1?: InputMaybe<HighlighterInput>;
  marker2?: InputMaybe<HighlighterInput>;
  marker3?: InputMaybe<HighlighterInput>;
  marker4?: InputMaybe<HighlighterInput>;
  marker5?: InputMaybe<HighlighterInput>;
};

export type HomeDailyTrivia = {
  __typename?: 'HomeDailyTrivia';
  done: Scalars['Boolean']['output'];
  resource?: Maybe<Resource>;
};

export type Images = {
  __typename?: 'Images';
  large: Scalars['String']['output'];
  medium: Scalars['String']['output'];
  original: Scalars['String']['output'];
  small: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
};

export type InLibrary = {
  __typename?: 'InLibrary';
  inLibrary: Scalars['Boolean']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  metadata: InviteMetadata;
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type InviteLegacy = {
  __typename?: 'InviteLegacy';
  metadata: InviteLegacyMetadata;
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export type InviteLegacyMetadata = {
  __typename?: 'InviteLegacyMetadata';
  invited_email: Scalars['String']['output'];
  library_id: Scalars['String']['output'];
  library_name: Scalars['String']['output'];
};

export type InviteMetadata = LibraryInviteMetadata | MeetupEventInviteMetadata | MindspaceInviteMetadata | ProgramInviteMetadata;

export enum InviteState {
  Expired = 'expired',
  Valid = 'valid'
}

export type InviteToLibraryInput = {
  emails: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type Launchpad = {
  __typename?: 'Launchpad';
  sections: Array<LaunchpadSection>;
};

export type LaunchpadItem = LaunchpadItemAssessment | LaunchpadItemDailyResource | LaunchpadItemDailyTrivia | LaunchpadItemLearnByFormat | LaunchpadItemObjective | LaunchpadItemProfile;

export type LaunchpadItemAssessment = {
  __typename?: 'LaunchpadItemAssessment';
  achievement?: Maybe<Achievement>;
  available: Scalars['Boolean']['output'];
  learningObjective?: Maybe<LearningObjective>;
  weeklyGuidance?: Maybe<WeeklyGuidance>;
};


export type LaunchpadItemAssessmentWeeklyGuidanceArgs = {
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type LaunchpadItemDailyResource = {
  __typename?: 'LaunchpadItemDailyResource';
  done: Scalars['Boolean']['output'];
  resource?: Maybe<Resource>;
};

export type LaunchpadItemDailyTrivia = {
  __typename?: 'LaunchpadItemDailyTrivia';
  done: Scalars['Boolean']['output'];
  resource?: Maybe<Resource>;
};

export type LaunchpadItemLearnByFormat = {
  __typename?: 'LaunchpadItemLearnByFormat';
  audio?: Maybe<Resource>;
  text?: Maybe<Resource>;
  video?: Maybe<Resource>;
};

export type LaunchpadItemObjective = {
  __typename?: 'LaunchpadItemObjective';
  learningObjective?: Maybe<LearningObjective>;
  mindspace?: Maybe<Mindspace>;
  weeklyGuidance?: Maybe<WeeklyGuidance>;
};


export type LaunchpadItemObjectiveWeeklyGuidanceArgs = {
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type LaunchpadItemProfile = {
  __typename?: 'LaunchpadItemProfile';
  profile?: Maybe<Profile>;
};

export type LaunchpadSection = {
  __typename?: 'LaunchpadSection';
  items: Array<LaunchpadItem>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  hasMore: Scalars['Boolean']['output'];
  items: Array<LeaderboardMember>;
  myRank?: Maybe<Scalars['Int']['output']>;
  nextItem?: Maybe<Scalars['Int']['output']>;
  orderBy?: Maybe<LeaderboardOrderBy>;
  total: Scalars['Int']['output'];
};

export type LeaderboardMember = {
  __typename?: 'LeaderboardMember';
  email?: Maybe<Scalars['String']['output']>;
  profile: Profile;
  stats: LeaderboardStats;
};

export enum LeaderboardOrderBy {
  Ep = 'EP',
  Progress = 'PROGRESS',
  PromptLevel = 'PROMPT_LEVEL',
  UseCasesCompleted = 'USE_CASES_COMPLETED',
  TimeSpent = 'TIME_SPENT'
}

export type LeaderboardStats = {
  __typename?: 'LeaderboardStats';
  badgeEarned: Scalars['Boolean']['output'];
  progressPercent: Scalars['Int']['output'];
  promptLevel: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  totalEP: Scalars['Int']['output'];
};

export type LearningObjective = {
  __typename?: 'LearningObjective';
  explanation: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objective: Scalars['String']['output'];
  targetDate?: Maybe<Scalars['String']['output']>;
  targetEP?: Maybe<Scalars['Int']['output']>;
};

export type LearningStats = {
  __typename?: 'LearningStats';
  bestStreak: Scalars['Int']['output'];
  completion: Scalars['Int']['output'];
  days: Scalars['Int']['output'];
  goal: GoalSettings;
  highlightsCount: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  notesCount: Scalars['Int']['output'];
  resourcesCount: Scalars['Int']['output'];
  streak: Scalars['Int']['output'];
  streaksPerDay: Array<StreakPerDay>;
  totalDays: Scalars['Int']['output'];
  totalMinutes: Scalars['Int']['output'];
  totalPoints: Scalars['Float']['output'];
};

export type LearningTask = {
  __typename?: 'LearningTask';
  id: Scalars['ID']['output'];
  learningTaskValidation: LearningTaskValidation;
};

export type LearningTaskImage = {
  __typename?: 'LearningTaskImage';
  done: Scalars['Boolean']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageDisplayUrls: Array<Scalars['String']['output']>;
  imageFileIds: Array<Scalars['String']['output']>;
  instructions: Scalars['String']['output'];
  points: LearningTaskPoints;
};

export type LearningTaskPoints = {
  __typename?: 'LearningTaskPoints';
  earnablePoints: Scalars['Float']['output'];
  earnedPoints: Scalars['Float']['output'];
};

export type LearningTaskSandbox = {
  __typename?: 'LearningTaskSandbox';
  chatThreadID?: Maybe<Scalars['ID']['output']>;
  done: Scalars['Boolean']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  points: LearningTaskPoints;
};

export type LearningTaskSandboxFeedback = {
  __typename?: 'LearningTaskSandboxFeedback';
  done: Scalars['Boolean']['output'];
  explanation: Scalars['String']['output'];
  feedbackValues?: Maybe<AiFeedbackVal>;
  message?: Maybe<AiMessage>;
  points: LearningTaskPoints;
  threadID?: Maybe<Scalars['ID']['output']>;
};

export type LearningTaskSandboxResponse = {
  __typename?: 'LearningTaskSandboxResponse';
  messages: Array<AiMessage>;
  threadID: Scalars['ID']['output'];
};

export type LearningTaskValidation = LearningTaskImage | LearningTaskSandbox;

export type LearningTaskValidationFeedback = {
  __typename?: 'LearningTaskValidationFeedback';
  done: Scalars['Boolean']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  messageID?: Maybe<Scalars['ID']['output']>;
  points: LearningTaskPoints;
  threadID?: Maybe<Scalars['ID']['output']>;
};

export type LibrariesResponse = {
  __typename?: 'LibrariesResponse';
  libraries: Array<Maybe<Library>>;
};

export type Library = {
  __typename?: 'Library';
  articleCount: Scalars['Int']['output'];
  canEdit: Scalars['Boolean']['output'];
  courseCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  highlighters?: Maybe<Highlighters>;
  id: Scalars['ID']['output'];
  inviteUrl: Scalars['String']['output'];
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  preferences?: Maybe<LibraryPreferences>;
  public: Scalars['Boolean']['output'];
  readOnly: Scalars['Boolean']['output'];
  shared: Scalars['Boolean']['output'];
  userCount: Scalars['Int']['output'];
};

export type LibraryHighlighterInput = {
  color: Scalars['String']['input'];
  label: Scalars['String']['input'];
  model: Scalars['String']['input'];
};

export type LibraryHighlightersInput = {
  marker0?: InputMaybe<LibraryHighlighterInput>;
  marker1?: InputMaybe<LibraryHighlighterInput>;
  marker2?: InputMaybe<LibraryHighlighterInput>;
  marker3?: InputMaybe<LibraryHighlighterInput>;
  marker4?: InputMaybe<LibraryHighlighterInput>;
  marker5?: InputMaybe<LibraryHighlighterInput>;
};

export type LibraryInviteLinkResponse = {
  __typename?: 'LibraryInviteLinkResponse';
  inviteUrl: Scalars['String']['output'];
};

export type LibraryInviteMetadata = {
  __typename?: 'LibraryInviteMetadata';
  invitedEmail: Scalars['String']['output'];
  libraryId: Scalars['String']['output'];
  libraryName: Scalars['String']['output'];
};

export type LibraryPreferences = {
  __typename?: 'LibraryPreferences';
  notificationArticleAddedToSharedLibrary: Scalars['Boolean']['output'];
  notificationUserJoinedLibrary: Scalars['Boolean']['output'];
  subscribeToNewArticles: Scalars['Boolean']['output'];
};

export type ListEvents = {
  __typename?: 'ListEvents';
  hasMore: Scalars['Boolean']['output'];
  list?: Maybe<Array<MindspaceEvent>>;
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListLibraryPrompts = {
  __typename?: 'ListLibraryPrompts';
  elements?: Maybe<Array<MindspaceLibraryPrompt>>;
  hasMore: Scalars['Boolean']['output'];
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListMindspaceObjectives = {
  __typename?: 'ListMindspaceObjectives';
  hasMore: Scalars['Boolean']['output'];
  list?: Maybe<Array<MindspaceObjective>>;
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListResourcesResponse = {
  __typename?: 'ListResourcesResponse';
  hasMore: Scalars['Boolean']['output'];
  nextItem?: Maybe<Scalars['Int']['output']>;
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type ListSandboxHistory = {
  __typename?: 'ListSandboxHistory';
  elements?: Maybe<Array<SandboxHistoryItem>>;
  hasMore: Scalars['Boolean']['output'];
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type LiveSessionFeedback = {
  __typename?: 'LiveSessionFeedback';
  cohortID: Scalars['ID']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  engagementRating?: Maybe<Scalars['Int']['output']>;
  enjoyedMost?: Maybe<Scalars['String']['output']>;
  eventID: Scalars['ID']['output'];
  improvementSuggestions?: Maybe<Scalars['String']['output']>;
  mindspaceID: Scalars['ID']['output'];
  programID: Scalars['ID']['output'];
  usefulnessRating?: Maybe<Scalars['Int']['output']>;
};

export type LiveSessionFeedbackInput = {
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  engagementRating?: InputMaybe<Scalars['Int']['input']>;
  enjoyedMost?: InputMaybe<Scalars['String']['input']>;
  improvementSuggestions?: InputMaybe<Scalars['String']['input']>;
  usefulnessRating?: InputMaybe<Scalars['Int']['input']>;
};

export type LoadResourceAndFeed = {
  __typename?: 'LoadResourceAndFeed';
  feed: Scalars['String']['output'];
  resourceID: Scalars['String']['output'];
};

export type LoadResourceInput = {
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  libraryID?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type LogAiUsageInput = {
  aiUsageActivities?: InputMaybe<Scalars['String']['input']>;
  focusText?: InputMaybe<Scalars['String']['input']>;
  mindspaceId: Scalars['ID']['input'];
  timeSavedHours: Scalars['Int']['input'];
  timeSpentHours: Scalars['Int']['input'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type MarkWeeklyGuidanceDayDone = {
  __typename?: 'MarkWeeklyGuidanceDayDone';
  done: Scalars['Boolean']['output'];
};

export type MeetupEventInviteMetadata = {
  __typename?: 'MeetupEventInviteMetadata';
  eventId: Scalars['String']['output'];
  mindspace: Mindspace;
  name: Scalars['String']['output'];
  profile: Profile;
};

export type Mindspace = {
  __typename?: 'Mindspace';
  admins: Array<Profile>;
  aiSandboxHistory: AiSandboxHistory;
  configuration?: Maybe<MindspaceConfiguration>;
  creationTime: Scalars['String']['output'];
  currentUserConfiguration?: Maybe<MindspaceUserConfiguration>;
  currentUserPermission?: Maybe<MindspacePermission>;
  description: Scalars['String']['output'];
  events?: Maybe<MindspaceEvents>;
  home: MindspaceHome;
  icon: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images: Images;
  invited?: Maybe<MindspaceInvitedListResponse>;
  members?: Maybe<MindspaceMemberListResponse>;
  mindspaceURL: Scalars['String']['output'];
  modules: MindspaceModuleConfiguration;
  name: Scalars['String']['output'];
  objectives?: Maybe<MindspaceObjectives>;
  programs?: Maybe<Programs>;
  promptLibrary?: Maybe<MindspacePromptLibrary>;
  requested?: Maybe<MindspaceRequestedListResponse>;
  resources: ListResourcesResponse;
  uniqueName: Scalars['String']['output'];
};


export type MindspaceInvitedArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<MindspaceRole>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};


export type MindspaceMembersArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<MindspaceRole>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Int']['input'];
};


export type MindspaceRequestedArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size: Scalars['Int']['input'];
};


export type MindspaceResourcesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};

export type MindspaceConfiguration = {
  __typename?: 'MindspaceConfiguration';
  inviteOnly: Scalars['Boolean']['output'];
  membersCanAddResources: Scalars['Boolean']['output'];
  public: Scalars['Boolean']['output'];
};

export type MindspaceConfigurationInput = {
  inviteOnly?: InputMaybe<Scalars['Boolean']['input']>;
  membersCanAddResources?: InputMaybe<Scalars['Boolean']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MindspaceEvent = {
  __typename?: 'MindspaceEvent';
  agenda: Array<AgendaItem>;
  attendance: EventAttendance;
  attended?: Maybe<Scalars['Boolean']['output']>;
  attending?: Maybe<Scalars['Boolean']['output']>;
  backgroundImage: Images;
  endDatetime: Scalars['String']['output'];
  eventDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  keyTakeaways: Scalars['String']['output'];
  liveSessionFeedback?: Maybe<LiveSessionFeedback>;
  location?: Maybe<EventLocation>;
  locationShort: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publicUrl: Scalars['String']['output'];
  redirectURL?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sponsors: Array<EventSponsor>;
  startDatetime: Scalars['String']['output'];
  state: EventState;
  tools: Array<Tool>;
};


export type MindspaceEventLiveSessionFeedbackArgs = {
  cohortID: Scalars['ID']['input'];
  eventID?: InputMaybe<Scalars['String']['input']>;
  programID: Scalars['ID']['input'];
};

export type MindspaceEvents = {
  __typename?: 'MindspaceEvents';
  event?: Maybe<MindspaceEvent>;
  list?: Maybe<ListEvents>;
  sponsors: Array<MindspaceSponsor>;
};


export type MindspaceEventsEventArgs = {
  identifier: Scalars['String']['input'];
};


export type MindspaceEventsListArgs = {
  filter?: InputMaybe<EventFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Sort>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type MindspaceHome = {
  __typename?: 'MindspaceHome';
  dailyTrivia?: Maybe<HomeDailyTrivia>;
};

export type MindspaceInviteInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<MindspaceRole>;
};

export type MindspaceInviteMetadata = {
  __typename?: 'MindspaceInviteMetadata';
  mindspace: Mindspace;
  mindspaceId: Scalars['String']['output'];
};

export type MindspaceInvited = {
  __typename?: 'MindspaceInvited';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  role: MindspaceRole;
  state: InviteState;
};

export type MindspaceInvitedListResponse = {
  __typename?: 'MindspaceInvitedListResponse';
  hasMore: Scalars['Boolean']['output'];
  invited: Array<MindspaceInvited>;
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type MindspaceLibraryPrompt = {
  __typename?: 'MindspaceLibraryPrompt';
  author: Profile;
  content: Scalars['String']['output'];
  description: Scalars['String']['output'];
  promptID: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  shareID: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type MindspaceMember = {
  __typename?: 'MindspaceMember';
  profile: Profile;
  role: MindspaceRole;
};

export type MindspaceMemberListResponse = {
  __typename?: 'MindspaceMemberListResponse';
  hasMore: Scalars['Boolean']['output'];
  nextItem?: Maybe<Scalars['Int']['output']>;
  profiles: Array<MindspaceMember>;
  total: Scalars['Int']['output'];
};

export type MindspaceMetadataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageFileID?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MindspaceModuleConfiguration = {
  __typename?: 'MindspaceModuleConfiguration';
  billing: Scalars['Boolean']['output'];
  events: Scalars['Boolean']['output'];
  objectives: Scalars['Boolean']['output'];
  programs: Scalars['Boolean']['output'];
  resources: Scalars['Boolean']['output'];
  sandbox: Scalars['Boolean']['output'];
  sandboxHistory: Scalars['Boolean']['output'];
};

export type MindspaceObjective = {
  __typename?: 'MindspaceObjective';
  achievement?: Maybe<Achievement>;
  id: Scalars['String']['output'];
  learningObjective: LearningObjective;
  state: MindspaceObjectiveState;
};

export enum MindspaceObjectiveState {
  Active = 'active',
  Archived = 'archived'
}

export type MindspaceObjectives = {
  __typename?: 'MindspaceObjectives';
  objective: MindspaceObjective;
  objectives: ListMindspaceObjectives;
};


export type MindspaceObjectivesObjectiveArgs = {
  id: Scalars['ID']['input'];
};


export type MindspaceObjectivesObjectivesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type MindspacePermission = {
  __typename?: 'MindspacePermission';
  canAddResource: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canLeave: Scalars['Boolean']['output'];
  canManageMembers: Scalars['Boolean']['output'];
  role: MindspaceRole;
};

export type MindspacePromptLibrary = {
  __typename?: 'MindspacePromptLibrary';
  list?: Maybe<ListLibraryPrompts>;
};


export type MindspacePromptLibraryListArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<PromptLibraryFilterSort>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type MindspaceRequested = {
  __typename?: 'MindspaceRequested';
  profile: Profile;
  role: MindspaceRole;
};

export type MindspaceRequestedListResponse = {
  __typename?: 'MindspaceRequestedListResponse';
  hasMore: Scalars['Boolean']['output'];
  nextItem?: Maybe<Scalars['Int']['output']>;
  profiles: Array<MindspaceRequested>;
  total: Scalars['Int']['output'];
};

export enum MindspaceRole {
  Admin = 'admin',
  Champion = 'champion',
  Coach = 'coach',
  Gatekeeper = 'gatekeeper',
  Member = 'member',
  Requested = 'requested'
}

export type MindspaceSponsor = {
  __typename?: 'MindspaceSponsor';
  sponsor: Sponsor;
};

export type MindspaceUpdateRoleInput = {
  inviteId?: InputMaybe<Scalars['String']['input']>;
  role: MindspaceRole;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MindspaceUserConfiguration = {
  __typename?: 'MindspaceUserConfiguration';
  notificationsMuted: Scalars['Boolean']['output'];
};

export type MindspaceUserConfigurationInput = {
  notificationsMuted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Mindspaces = {
  __typename?: 'Mindspaces';
  all: Array<Mindspace>;
  mine: Array<Mindspace>;
  others: Array<Mindspace>;
};

export type Mindstream = {
  __typename?: 'Mindstream';
  nextItem: Scalars['Int']['output'];
  resources: Array<Maybe<Resource>>;
  total: Scalars['Int']['output'];
};

export type MoveResourceToLibraryInput = {
  asResource?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  keepOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  libraryID: Scalars['ID']['input'];
};

export type MoveResourcesToLibraryInput = {
  ids: Array<Scalars['ID']['input']>;
  keepOriginals?: InputMaybe<Scalars['Boolean']['input']>;
  libraryID: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: Scalars['Boolean']['output'];
  acceptLibraryInvite: Scalars['Boolean']['output'];
  addDemoVote: Scalars['Boolean']['output'];
  addLearningObjective: LearningObjective;
  addResourceFromFile: Resource;
  addSharedHighlight: SharedHighlight;
  addToMindstream: Scalars['Boolean']['output'];
  aiAsk: AiAskResponse;
  aiAssessment: AiAssessmentResponse;
  aiPersonalizer?: Maybe<AiPersonalizerResponse>;
  aiSandbox: AiSandboxResponse;
  aiSimplify: AiAskResponse;
  aiSummarise: AiAskResponse;
  aiTranslate: AiAskResponse;
  aiUseCaseFinder: AiUseCaseFinderResponse;
  aiWebExtension: AiWebExtensionResponse;
  aiWebSearch: AiWebSearchResponse;
  archiveResources: Scalars['Boolean']['output'];
  authenticate?: Maybe<AuthenticateResponse>;
  cohortJoin: CohortJoin;
  cohortLeave: Scalars['Boolean']['output'];
  completeLearningObjective: Scalars['Boolean']['output'];
  completeLearningTaskImage: LearningTaskValidationFeedback;
  completeLearningTaskSandbox: LearningTaskSandboxResponse;
  completeUseCase: UseCaseCompletionResponse;
  copyResourceToLibrary: Resource;
  createAnnotationHighlight: AnnotationHighlight;
  createBillingSubscription: BillingSubscription;
  createComment: Comment;
  createHTMLComment?: Maybe<HtmlComment>;
  createHighlight: Highlight;
  createLead: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  createLibrary: Library;
  /** @deprecated No longer supported */
  createLibraryInviteLink: LibraryInviteLinkResponse;
  createMindspace: Mindspace;
  createPDFComment?: Maybe<PdfComment>;
  createResourceComment?: Maybe<ResourceComment>;
  deleteAccount: Scalars['Boolean']['output'];
  deleteCohortUser: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteHighlight: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  deleteLibrary: Scalars['Boolean']['output'];
  deleteLibraryPrompt: Scalars['Boolean']['output'];
  deleteMindspace: Scalars['Boolean']['output'];
  deleteResource: Scalars['ID']['output'];
  deleteResources: Scalars['Boolean']['output'];
  deleteSandboxHistory: Scalars['Boolean']['output'];
  deleteScrapingRule: Scalars['Boolean']['output'];
  editAnnotationHighlight: AnnotationHighlight;
  /** @deprecated No longer supported */
  editLibraryDescription: Scalars['Boolean']['output'];
  event: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  exportLibrary: Scalars['Boolean']['output'];
  exportResource: Scalars['String']['output'];
  filePrepare: FilePrepareResponse;
  followProfile: Scalars['Boolean']['output'];
  followResource: Scalars['Boolean']['output'];
  forgotPasswordWithPin: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  generateTextToSpeech: TextToSpeech;
  genericFeedback: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  inviteToLibrary: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  leaveLibrary: Scalars['Boolean']['output'];
  loadResource: Scalars['ID']['output'];
  /** @deprecated No longer supported */
  loadResourceAndFeed: LoadResourceAndFeed;
  logAIUsage: Scalars['Boolean']['output'];
  login?: Maybe<LoginResponse>;
  loginWithPin: LoginResponse;
  markAllNotificationsAsRead: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  markNotificationAsRead: Scalars['Boolean']['output'];
  markNotificationsAsRead: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  markWeeklyGuidanceDayDone?: Maybe<MarkWeeklyGuidanceDayDone>;
  /** @deprecated No longer supported */
  messageAllUsers: Scalars['Boolean']['output'];
  mindspaceAddArticle: Resource;
  mindspaceAddArticles: Array<Resource>;
  mindspaceConfirmRSVP: Scalars['Boolean']['output'];
  mindspaceEventAttend: Scalars['Boolean']['output'];
  mindspaceEventGeneratePkPass: Scalars['String']['output'];
  mindspaceEventRSVP: Scalars['Boolean']['output'];
  mindspaceEventSelfAttend: Scalars['Boolean']['output'];
  mindspaceInvite: Array<MindspaceInvited>;
  mindspaceInviteCSV: Array<MindspaceInvited>;
  mindspaceInviteCancel: Scalars['Boolean']['output'];
  mindspaceInviteResend: Scalars['Boolean']['output'];
  mindspaceJoin: Scalars['Boolean']['output'];
  mindspaceJoinApprove: Scalars['Boolean']['output'];
  mindspaceJoinRemove: Scalars['Boolean']['output'];
  mindspaceMoveArticle: Resource;
  mindspaceReinvitePending: Array<MindspaceInvited>;
  mindspaceRemoveArticle: Scalars['Boolean']['output'];
  mindspaceRemoveArticles: Scalars['Boolean']['output'];
  mindspaceRemoveMember: Scalars['Boolean']['output'];
  mindspaceUpdateRole: Scalars['Boolean']['output'];
  moveResourceToLibrary: Resource;
  moveResourcesToLibrary: Scalars['Boolean']['output'];
  personalizeProgram?: Maybe<Program>;
  preregisterCohortUsers: Scalars['Boolean']['output'];
  readAnnouncements: Scalars['Boolean']['output'];
  recordResourceReadingProgress: Scalars['Boolean']['output'];
  recordUserReadingProgress: Scalars['Boolean']['output'];
  refreshToken: Scalars['String']['output'];
  reinviteAllPreregistrations: Scalars['Boolean']['output'];
  removeDemoVote: Scalars['Boolean']['output'];
  removeFromMindstream: Scalars['Boolean']['output'];
  removePushNotificationToken: Scalars['Boolean']['output'];
  removeResources: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  removeUserFromLibrary: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  renameLibrary: Scalars['Boolean']['output'];
  renameResource: Resource;
  repersonalizeProgram?: Maybe<Program>;
  reportResource: Scalars['Boolean']['output'];
  requestLoginPin: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  resendLibraryExpiredInvites: ResendExpiredResponse;
  resetPassword: Scalars['Boolean']['output'];
  resetPasswordWithPin: Scalars['Boolean']['output'];
  savePrompt: SavePromptResponse;
  savePushNotificationToken: Scalars['Boolean']['output'];
  saveScrapingRule: Scalars['Boolean']['output'];
  sectionItemComplete: Scalars['Boolean']['output'];
  sendCohortEmail: SendCohortEmailResponse;
  setPreferences: Preferences;
  setReadingGoal: Scalars['Boolean']['output'];
  setReadingTime: Scalars['Boolean']['output'];
  setResourceFolder: Resource;
  setResourcePrivacy: Resource;
  setResourcesFolder: Scalars['Boolean']['output'];
  setUTMParams: Scalars['Boolean']['output'];
  setUserReadingGoal: Scalars['Boolean']['output'];
  setUserReadingTimeOfDay: Scalars['Boolean']['output'];
  shareResource: Scalars['Boolean']['output'];
  signup: SignupResponse;
  snoozeResourceInFlow: Scalars['Boolean']['output'];
  startTimeoutTriviaAnswer: Scalars['Boolean']['output'];
  stripePaymentMade: Scalars['Boolean']['output'];
  submitDemo: Scalars['Boolean']['output'];
  submitLiveSessionFeedback: Scalars['Boolean']['output'];
  submitNPSSurveyResponse: Scalars['Boolean']['output'];
  submitSurvey: Scalars['Boolean']['output'];
  submitTriviaAnswer: TriviaResult;
  submitWeeklyGuidanceTriviaAnswer: TriviaResult;
  submitWeeklyGuidanceTriviaFreetextAnswer: TriviaFreetextResult;
  timeoutTriviaAnswer: TriviaResult;
  timeoutWeeklyGuidanceTriviaAnswer: TriviaResult;
  undoDeleteResource: Scalars['Boolean']['output'];
  undoDeleteResources: Scalars['Boolean']['output'];
  unfollowProfile: Scalars['Boolean']['output'];
  unfollowResource: Scalars['Boolean']['output'];
  updateFlowOrder: Scalars['Boolean']['output'];
  updateFullName: Scalars['Boolean']['output'];
  updateHighlight: Highlight;
  /** @deprecated No longer supported */
  updateLibraryHighlighters: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  updateLibraryPreferences: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  updateLibraryUserRole: Scalars['Boolean']['output'];
  updateMindspace: Mindspace;
  updateMindspaceConfiguration: Mindspace;
  updateMindspaceUserConfiguration?: Maybe<MindspaceUserConfiguration>;
  updateName: Scalars['Boolean']['output'];
  updatePrivateNote?: Maybe<AnnotationComment>;
  updateProfile?: Maybe<Profile>;
  updateResourceHighlighters: Resource;
  updateResourceImage: Scalars['Boolean']['output'];
  updateResourceReadState: Scalars['Boolean']['output'];
  updateResourceSubscription: Scalars['Boolean']['output'];
  updateResourceTags: Resource;
  updateResourceUserProgress: Scalars['Boolean']['output'];
  updateResourcesReadState: Scalars['Boolean']['output'];
  updateUserMetadata: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  updateUserOnboarded: Scalars['Boolean']['output'];
  updateUserPicture: Scalars['Boolean']['output'];
  updateUserStateStore: StateStore;
  updateUsername: Scalars['Boolean']['output'];
  uploadUserPicture: Scalars['Boolean']['output'];
  userFeedback: Scalars['Boolean']['output'];
  validateBillingSubscription: Scalars['Boolean']['output'];
  validateForgotPasswordPin: Scalars['Boolean']['output'];
  validateUsername: Scalars['Boolean']['output'];
  weeklyLearningStatsShowed: Scalars['Boolean']['output'];
};


export type MutationAcceptInviteArgs = {
  code: Scalars['String']['input'];
};


export type MutationAcceptLibraryInviteArgs = {
  code: Scalars['String']['input'];
};


export type MutationAddDemoVoteArgs = {
  cohortId: Scalars['ID']['input'];
  demoId: Scalars['ID']['input'];
  mindspaceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationAddLearningObjectiveArgs = {
  objective?: InputMaybe<Scalars['String']['input']>;
  objectiveId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddResourceFromFileArgs = {
  body: AddResourceFromFileInput;
};


export type MutationAddSharedHighlightArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationAddToMindstreamArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAiAskArgs = {
  context: AiContext;
  idempotencyID?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAiAssessmentArgs = {
  context?: InputMaybe<AiContext>;
  idempotencyID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAiPersonalizerArgs = {
  context?: InputMaybe<PersonalizerContext>;
  idempotencyID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAiSandboxArgs = {
  context: AiContext;
  idempotencyID: Scalars['ID']['input'];
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
};


export type MutationAiSimplifyArgs = {
  context: AiContext;
  idempotencyID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAiSummariseArgs = {
  context: AiContext;
  idempotencyID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAiTranslateArgs = {
  context: AiContext;
  idempotencyID?: InputMaybe<Scalars['ID']['input']>;
  language: Scalars['String']['input'];
};


export type MutationAiUseCaseFinderArgs = {
  anonymousUserID: Scalars['ID']['input'];
  idempotencyID: Scalars['ID']['input'];
  industry: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type MutationAiWebExtensionArgs = {
  context?: InputMaybe<AiWebExtensionContext>;
  idempotencyID: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type MutationAiWebSearchArgs = {
  context: AiContext;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveResourcesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAuthenticateArgs = {
  body: AuthenticateInput;
};


export type MutationCohortJoinArgs = {
  appleTransactionID?: InputMaybe<Scalars['String']['input']>;
  appleTransactionJws?: InputMaybe<Scalars['String']['input']>;
  cohortID: Scalars['ID']['input'];
  isMoreSeats?: InputMaybe<Scalars['Boolean']['input']>;
  mindspaceIdentifier: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  stripeSessionID?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCohortLeaveArgs = {
  cohortID: Scalars['ID']['input'];
  mindspaceIdentifier: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationCompleteLearningObjectiveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCompleteLearningTaskImageArgs = {
  cohortID: Scalars['ID']['input'];
  imageFileIDs: Array<Scalars['ID']['input']>;
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
  taskID: Scalars['ID']['input'];
  userComment?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteLearningTaskSandboxArgs = {
  chatThreadID?: InputMaybe<Scalars['ID']['input']>;
  cohortID: Scalars['ID']['input'];
  idempotencyID: Scalars['ID']['input'];
  imageFileIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};


export type MutationCompleteUseCaseArgs = {
  imageFileIDs: Array<Scalars['ID']['input']>;
  ownerID: Scalars['ID']['input'];
  useCaseID: Scalars['ID']['input'];
};


export type MutationCopyResourceToLibraryArgs = {
  body: CopyResourceToLibraryInput;
};


export type MutationCreateAnnotationHighlightArgs = {
  articleId: Scalars['ID']['input'];
  htmlHighlightInput?: InputMaybe<HtmlHighlightInput>;
  pdfHighlightInput?: InputMaybe<PdfHighlightInput>;
};


export type MutationCreateBillingSubscriptionArgs = {
  recurrence: BillingRecurrence;
  seats?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateCommentArgs = {
  articleId: Scalars['ID']['input'];
  commentInput: CommentInput;
  highlightId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateHtmlCommentArgs = {
  articleId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  highlightId: Scalars['ID']['input'];
};


export type MutationCreateHighlightArgs = {
  articleId: Scalars['ID']['input'];
  highlightInput: HighlightInput;
};


export type MutationCreateLeadArgs = {
  anonymousUserID: Scalars['ID']['input'];
  callScheduleType?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  companySize: Scalars['String']['input'];
  email: Scalars['String']['input'];
  heardFrom?: InputMaybe<Scalars['String']['input']>;
  industry: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
  source: Scalars['String']['input'];
  subscribe: Scalars['Boolean']['input'];
};


export type MutationCreateLibraryArgs = {
  body?: InputMaybe<CreateLibraryInput>;
};


export type MutationCreateLibraryInviteLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateMindspaceArgs = {
  configuration: MindspaceConfigurationInput;
  metadata: MindspaceMetadataInput;
  uniqueName: Scalars['String']['input'];
};


export type MutationCreatePdfCommentArgs = {
  articleId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  highlightId: Scalars['ID']['input'];
  xfdfString: Scalars['String']['input'];
};


export type MutationCreateResourceCommentArgs = {
  articleId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type MutationDeleteCohortUserArgs = {
  cohortID: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  articleId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteHighlightArgs = {
  articleId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};


export type MutationDeleteLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLibraryPromptArgs = {
  mindspaceID: Scalars['ID']['input'];
  shareID: Scalars['ID']['input'];
};


export type MutationDeleteMindspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResourcesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteSandboxHistoryArgs = {
  mindspaceID: Scalars['ID']['input'];
  threadID: Scalars['ID']['input'];
};


export type MutationDeleteScrapingRuleArgs = {
  domain: Scalars['String']['input'];
};


export type MutationEditAnnotationHighlightArgs = {
  articleId: Scalars['ID']['input'];
  highlightId: Scalars['ID']['input'];
  htmlHighlightInput?: InputMaybe<HtmlHighlightInput>;
  pdfHighlightInput?: InputMaybe<PdfHighlightInput>;
};


export type MutationEditLibraryDescriptionArgs = {
  body?: InputMaybe<EditLibraryDescriptionInput>;
};


export type MutationEventArgs = {
  extraData?: InputMaybe<Array<ExtraDataTuple>>;
  name: Scalars['String']['input'];
};


export type MutationExportLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationExportResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFilePrepareArgs = {
  contentType: Scalars['String']['input'];
};


export type MutationFollowProfileArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationFollowResourceArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationForgotPasswordWithPinArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateTextToSpeechArgs = {
  articleId: Scalars['ID']['input'];
};


export type MutationGenericFeedbackArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  positiveReview?: InputMaybe<Scalars['Boolean']['input']>;
  relatedId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteToLibraryArgs = {
  body?: InputMaybe<InviteToLibraryInput>;
};


export type MutationLeaveLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoadResourceArgs = {
  data: LoadResourceInput;
};


export type MutationLoadResourceAndFeedArgs = {
  data: LoadResourceInput;
};


export type MutationLogAiUsageArgs = {
  input: LogAiUsageInput;
};


export type MutationLoginArgs = {
  body: LoginInput;
};


export type MutationLoginWithPinArgs = {
  email: Scalars['String']['input'];
  pin: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNotificationsAsReadArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationMarkWeeklyGuidanceDayDoneArgs = {
  dayNumber: Scalars['Int']['input'];
  objectiveID: Scalars['String']['input'];
  phaseNumber: Scalars['Int']['input'];
  weekNumber: Scalars['Int']['input'];
};


export type MutationMessageAllUsersArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};


export type MutationMindspaceAddArticleArgs = {
  articleId: Scalars['ID']['input'];
  copyAnnotation?: InputMaybe<Scalars['Boolean']['input']>;
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceAddArticlesArgs = {
  articleIds: Array<Scalars['ID']['input']>;
  copyAnnotation?: InputMaybe<Scalars['Boolean']['input']>;
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceConfirmRsvpArgs = {
  attend: Scalars['Boolean']['input'];
  eventIdentifier: Scalars['ID']['input'];
  mindspaceIdentifier: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};


export type MutationMindspaceEventAttendArgs = {
  attendeeUniqueName: Scalars['String']['input'];
  eventIdentifier: Scalars['ID']['input'];
  mindspaceIdentifier: Scalars['ID']['input'];
};


export type MutationMindspaceEventGeneratePkPassArgs = {
  eventIdentifier: Scalars['ID']['input'];
  mindspaceIdentifier: Scalars['ID']['input'];
};


export type MutationMindspaceEventRsvpArgs = {
  attend: Scalars['Boolean']['input'];
  eventIdentifier: Scalars['ID']['input'];
  mindspaceIdentifier: Scalars['ID']['input'];
};


export type MutationMindspaceEventSelfAttendArgs = {
  eventIdentifier: Scalars['ID']['input'];
};


export type MutationMindspaceInviteArgs = {
  invites: Array<MindspaceInviteInput>;
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceInviteCsvArgs = {
  base64data: Scalars['String']['input'];
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceInviteCancelArgs = {
  inviteIds: Array<Scalars['ID']['input']>;
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceInviteResendArgs = {
  inviteId: Scalars['ID']['input'];
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceJoinArgs = {
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceJoinApproveArgs = {
  mindspaceId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationMindspaceJoinRemoveArgs = {
  mindspaceId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationMindspaceMoveArticleArgs = {
  articleId: Scalars['ID']['input'];
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceReinvitePendingArgs = {
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceRemoveArticleArgs = {
  articleId: Scalars['ID']['input'];
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceRemoveArticlesArgs = {
  articleIds: Array<Scalars['ID']['input']>;
  mindspaceId: Scalars['ID']['input'];
};


export type MutationMindspaceRemoveMemberArgs = {
  mindspaceId: Scalars['ID']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationMindspaceUpdateRoleArgs = {
  mindspaceId: Scalars['ID']['input'];
  updates: Array<MindspaceUpdateRoleInput>;
};


export type MutationMoveResourceToLibraryArgs = {
  body: MoveResourceToLibraryInput;
};


export type MutationMoveResourcesToLibraryArgs = {
  body: MoveResourcesToLibraryInput;
};


export type MutationPersonalizeProgramArgs = {
  cohortID: Scalars['ID']['input'];
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationPreregisterCohortUsersArgs = {
  cohortID: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationRecordResourceReadingProgressArgs = {
  id: Scalars['ID']['input'];
  resourceProgress?: InputMaybe<ResourceReadingProgress>;
  seconds: Scalars['Int']['input'];
};


export type MutationRecordUserReadingProgressArgs = {
  seconds: Scalars['Int']['input'];
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationReinviteAllPreregistrationsArgs = {
  cohortID: Scalars['ID']['input'];
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationRemoveDemoVoteArgs = {
  cohortId: Scalars['ID']['input'];
  demoId: Scalars['ID']['input'];
  mindspaceId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationRemoveFromMindstreamArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRemovePushNotificationTokenArgs = {
  deviceType: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRemoveResourcesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRemoveUserFromLibraryArgs = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRenameLibraryArgs = {
  body?: InputMaybe<RenameLibraryInput>;
};


export type MutationRenameResourceArgs = {
  body: RenameResourceInput;
};


export type MutationRepersonalizeProgramArgs = {
  cohortID: Scalars['ID']['input'];
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationReportResourceArgs = {
  body: ReportResourceInput;
};


export type MutationRequestLoginPinArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendLibraryExpiredInvitesArgs = {
  body?: InputMaybe<ResentExpiredInvitesInput>;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationResetPasswordWithPinArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  pin: Scalars['String']['input'];
};


export type MutationSavePromptArgs = {
  description: Scalars['String']['input'];
  messageID: Scalars['ID']['input'];
  mindspaceID: Scalars['ID']['input'];
  threadID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationSavePushNotificationTokenArgs = {
  deviceType: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveScrapingRuleArgs = {
  domain: Scalars['String']['input'];
  rule?: InputMaybe<RuleInput>;
};


export type MutationSectionItemCompleteArgs = {
  cohortID: Scalars['ID']['input'];
  mindspaceIdentifier: Scalars['ID']['input'];
  sectionItemID: Scalars['ID']['input'];
};


export type MutationSendCohortEmailArgs = {
  cohortID: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  mindspaceID: Scalars['ID']['input'];
  recipientEmails: Array<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};


export type MutationSetPreferencesArgs = {
  preferences: SetPreferencesInput;
};


export type MutationSetReadingGoalArgs = {
  minutes: Scalars['Int']['input'];
};


export type MutationSetReadingTimeArgs = {
  hour: Scalars['Int']['input'];
  minutes: Scalars['Int']['input'];
};


export type MutationSetResourceFolderArgs = {
  body: SetResourceFolderInput;
};


export type MutationSetResourcePrivacyArgs = {
  body: SetResourcePrivacyInput;
};


export type MutationSetResourcesFolderArgs = {
  body: SetResourcesFolderInput;
};


export type MutationSetUtmParamsArgs = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetUserReadingGoalArgs = {
  minutes: Scalars['Int']['input'];
};


export type MutationSetUserReadingTimeOfDayArgs = {
  timeofday: Scalars['String']['input'];
};


export type MutationShareResourceArgs = {
  articleId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
  shareReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSignupArgs = {
  body: SignupInput;
};


export type MutationSnoozeResourceInFlowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartTimeoutTriviaAnswerArgs = {
  articleID: Scalars['ID']['input'];
  questionID: Scalars['ID']['input'];
};


export type MutationStripePaymentMadeArgs = {
  paymentIntentID: Scalars['String']['input'];
};


export type MutationSubmitDemoArgs = {
  cohortID: Scalars['ID']['input'];
  dayID: Scalars['ID']['input'];
  demoID?: InputMaybe<Scalars['ID']['input']>;
  input: DemoSubmissionInput;
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationSubmitLiveSessionFeedbackArgs = {
  cohortID: Scalars['ID']['input'];
  eventID: Scalars['ID']['input'];
  input: LiveSessionFeedbackInput;
  mindspaceID: Scalars['ID']['input'];
  programID: Scalars['ID']['input'];
};


export type MutationSubmitNpsSurveyResponseArgs = {
  cohortID?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  mindspaceID?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
};


export type MutationSubmitSurveyArgs = {
  answers: Array<SurveyResponse>;
  cohortID?: InputMaybe<Scalars['ID']['input']>;
  mindspaceID: Scalars['ID']['input'];
  programID?: InputMaybe<Scalars['ID']['input']>;
  surveyType: SurveyType;
};


export type MutationSubmitTriviaAnswerArgs = {
  answerID: Scalars['ID']['input'];
  articleID: Scalars['ID']['input'];
  mindspaceID?: InputMaybe<Scalars['ID']['input']>;
  questionID: Scalars['ID']['input'];
};


export type MutationSubmitWeeklyGuidanceTriviaAnswerArgs = {
  answerID: Scalars['ID']['input'];
  articleID: Scalars['ID']['input'];
  questionID: Scalars['ID']['input'];
};


export type MutationSubmitWeeklyGuidanceTriviaFreetextAnswerArgs = {
  answer: Scalars['String']['input'];
  articleID: Scalars['ID']['input'];
  questionID: Scalars['ID']['input'];
};


export type MutationTimeoutTriviaAnswerArgs = {
  articleID: Scalars['ID']['input'];
  questionID: Scalars['ID']['input'];
};


export type MutationTimeoutWeeklyGuidanceTriviaAnswerArgs = {
  articleID: Scalars['ID']['input'];
  questionID: Scalars['ID']['input'];
};


export type MutationUndoDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUndoDeleteResourcesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUnfollowProfileArgs = {
  userID: Scalars['ID']['input'];
};


export type MutationUnfollowResourceArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateFlowOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateFullNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateHighlightArgs = {
  articleId: Scalars['ID']['input'];
  highlightInput: HighlightInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLibraryHighlightersArgs = {
  body: UpdateLibraryHighlightersInput;
};


export type MutationUpdateLibraryPreferencesArgs = {
  id: Scalars['ID']['input'];
  preferences: UpdateLibraryPreferencesInput;
};


export type MutationUpdateLibraryUserRoleArgs = {
  id: Scalars['ID']['input'];
  role: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};


export type MutationUpdateMindspaceArgs = {
  data: MindspaceMetadataInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMindspaceConfigurationArgs = {
  data: MindspaceConfigurationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMindspaceUserConfigurationArgs = {
  data: MindspaceUserConfigurationInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateNameArgs = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  giveName: Scalars['String']['input'];
};


export type MutationUpdatePrivateNoteArgs = {
  articleID: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  highlightID: Scalars['ID']['input'];
  xfdfString?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProfileArgs = {
  profile: ProfileInput;
};


export type MutationUpdateResourceHighlightersArgs = {
  body: UpdateResourceHighlightersInput;
};


export type MutationUpdateResourceImageArgs = {
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};


export type MutationUpdateResourceReadStateArgs = {
  id: Scalars['ID']['input'];
  read: Scalars['Boolean']['input'];
  readTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateResourceSubscriptionArgs = {
  id: Scalars['ID']['input'];
  subscribed: Scalars['Boolean']['input'];
};


export type MutationUpdateResourceTagsArgs = {
  body: UpdateResourceTagsInput;
};


export type MutationUpdateResourceUserProgressArgs = {
  body: UpdateResourceUserProgressInput;
};


export type MutationUpdateResourcesReadStateArgs = {
  ids: Array<Scalars['ID']['input']>;
  read: Scalars['Boolean']['input'];
  readTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserMetadataArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserOnboardedArgs = {
  onboarded: Scalars['Boolean']['input'];
};


export type MutationUpdateUserPictureArgs = {
  picture: Scalars['String']['input'];
};


export type MutationUpdateUserStateStoreArgs = {
  aiUsageLastDismissedAt?: InputMaybe<Scalars['String']['input']>;
  extensionPromoLastDismissedAt?: InputMaybe<Scalars['String']['input']>;
  programSwitchSeen?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionHomeSeen?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionUpgradeSeen?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationUploadUserPictureArgs = {
  pictureBase64: Scalars['String']['input'];
};


export type MutationUserFeedbackArgs = {
  feedback: Scalars['String']['input'];
};


export type MutationValidateBillingSubscriptionArgs = {
  stripeSessionId: Scalars['String']['input'];
};


export type MutationValidateForgotPasswordPinArgs = {
  email: Scalars['String']['input'];
  pin: Scalars['String']['input'];
};


export type MutationValidateUsernameArgs = {
  username: Scalars['String']['input'];
};


export type MutationWeeklyLearningStatsShowedArgs = {
  showed: Scalars['Boolean']['input'];
};

export type NpsScore = {
  __typename?: 'NPSScore';
  cohortID?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  submittedFrom: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
};

export type NonCompleter = {
  __typename?: 'NonCompleter';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  actionURL?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type NotificationItem = {
  __typename?: 'NotificationItem';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata: Scalars['Map']['output'];
  read: Scalars['Boolean']['output'];
  relatedId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type NotificationsPage = {
  __typename?: 'NotificationsPage';
  items: Array<Notification>;
  nextItem?: Maybe<Scalars['String']['output']>;
  unreadCount: Scalars['Int']['output'];
};

export type OAuthConfig = {
  __typename?: 'OAuthConfig';
  apple: Scalars['String']['output'];
  google: Scalars['String']['output'];
  linkedIn: Scalars['String']['output'];
  microsoft: Scalars['String']['output'];
  microsoftClientId: Scalars['String']['output'];
};

export type OnTrackMetrics = {
  __typename?: 'OnTrackMetrics';
  avgEPs: Scalars['Float']['output'];
  promptLevel: Scalars['Float']['output'];
  promptsTested: Scalars['Float']['output'];
  totalUsers: Scalars['Int']['output'];
  usersOnTrack: Scalars['Int']['output'];
};

export type OnlineLocation = {
  __typename?: 'OnlineLocation';
  joinUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PdfComment = AnnotationComment & AnnotationHighlightComment & {
  __typename?: 'PDFComment';
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt: Scalars['String']['output'];
  highlight: AnnotationHighlight;
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  profile: Profile;
  resource: Resource;
  xfdfString: Scalars['String']['output'];
};

export type PdfHighlight = AnnotationHighlight & {
  __typename?: 'PDFHighlight';
  canEdit: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  comments: Array<AnnotationHighlightComment>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  page: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  privateNote?: Maybe<AnnotationHighlightComment>;
  profile: Profile;
  resource: Resource;
  suffix: Scalars['String']['output'];
  text: Scalars['String']['output'];
  xfdfString: Scalars['String']['output'];
};

export type PdfHighlightInput = {
  color: Scalars['String']['input'];
  model: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  prefix: Scalars['String']['input'];
  suffix: Scalars['String']['input'];
  text: Scalars['String']['input'];
  xfdfString: Scalars['String']['input'];
};

export enum Period {
  CurrentWeek = 'currentWeek',
  PreviousWeek = 'previousWeek'
}

export enum PersonalizationStatusCode {
  CompletedPersonalization = 'COMPLETED_PERSONALIZATION',
  CompletedSteps = 'COMPLETED_STEPS',
  Failed = 'FAILED',
  Started = 'STARTED'
}

export type PersonalizationUpdate = {
  __typename?: 'PersonalizationUpdate';
  idempotencyID: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: PersonalizationStatusCode;
  useCasesWithSteps?: Maybe<Array<UseCase>>;
  userId: Scalars['ID']['output'];
};

export type PreRegistration = {
  __typename?: 'PreRegistration';
  email: Scalars['String']['output'];
  inviteId: Scalars['String']['output'];
};

export type PreRegistrationList = {
  __typename?: 'PreRegistrationList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PreRegistration>;
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type PreferenceState = {
  __typename?: 'PreferenceState';
  orderBy?: Maybe<Scalars['String']['output']>;
};

export type Preferences = {
  __typename?: 'Preferences';
  orderBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  state?: Maybe<PreferenceState>;
  theme?: Maybe<Scalars['String']['output']>;
};

export type ProTip = {
  __typename?: 'ProTip';
  content: Scalars['String']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  achievement: Achievement;
  achievements: AchievementListResponse;
  bio?: Maybe<Scalars['String']['output']>;
  canShare: Scalars['Boolean']['output'];
  company?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  evidencing: Evidencing;
  firstName?: Maybe<Scalars['String']['output']>;
  followers: ProfileListResponse;
  following: Scalars['Boolean']['output'];
  followings: ProfileListResponse;
  hasAddedResources: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  joinedDate: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Array<ProfileLevel>>;
  mindstream?: Maybe<Mindstream>;
  mine: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['String']['output']>;
  profilePictureURL: Scalars['String']['output'];
  profileUrl?: Maybe<Scalars['String']['output']>;
  programs: Array<ProfileProgram>;
  pronouns?: Maybe<Scalars['String']['output']>;
  roleContextShort: Scalars['String']['output'];
  tagLine?: Maybe<Scalars['String']['output']>;
  useCases: Array<UseCase>;
  username: Scalars['String']['output'];
};


export type ProfileAchievementArgs = {
  id: Scalars['ID']['input'];
};


export type ProfileEvidencingArgs = {
  groupBy?: InputMaybe<GroupByTime>;
  period?: InputMaybe<Scalars['String']['input']>;
};


export type ProfileFollowersArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size: Scalars['Int']['input'];
};


export type ProfileFollowingsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size: Scalars['Int']['input'];
};


export type ProfileMindstreamArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProfileUseCasesArgs = {
  completedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inCompleteOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  profilePictureFileID?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  tagLine?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileLevel = {
  __typename?: 'ProfileLevel';
  breakdown?: Maybe<Array<ProfileLevelBreakdown>>;
  label: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  type: ProfileLevelType;
};

export type ProfileLevelBreakdown = {
  __typename?: 'ProfileLevelBreakdown';
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum ProfileLevelType {
  Prompting = 'prompting'
}

export type ProfileListResponse = {
  __typename?: 'ProfileListResponse';
  hasMore: Scalars['Boolean']['output'];
  nextItem?: Maybe<Scalars['Int']['output']>;
  profiles: Array<Profile>;
  total: Scalars['Int']['output'];
};

export type ProfileProgram = {
  __typename?: 'ProfileProgram';
  badgeEarned: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  metadata: ProgramMetadata;
  mindspaceName: Scalars['String']['output'];
};

export type Program = {
  __typename?: 'Program';
  cohort: Cohort;
  cohorts: Array<Cohort>;
  hasEnrolled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  metadata: ProgramMetadata;
};


export type ProgramCohortArgs = {
  cohortID?: InputMaybe<Scalars['ID']['input']>;
};

export type ProgramCompletion = {
  __typename?: 'ProgramCompletion';
  assessmentNonCompleters: Array<NonCompleter>;
  assessmentPassed: Scalars['Int']['output'];
  contentNonCompleters: Array<NonCompleter>;
  criteria: CompletionCriteria;
  eligibleForAssessment: Scalars['Int']['output'];
  evidencePointsNonCompleters: Array<NonCompleter>;
  noPromptTargetLevel: Scalars['Boolean']['output'];
  promptLevelNonCompleters: Array<NonCompleter>;
  totalLearners: Scalars['Int']['output'];
};

export type ProgramInviteMetadata = {
  __typename?: 'ProgramInviteMetadata';
  mindspace: Mindspace;
  mindspaceId: Scalars['String']['output'];
  program: Program;
};

export type ProgramMetadata = {
  __typename?: 'ProgramMetadata';
  description: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  images: Images;
  isPearsonProgram: Scalars['Boolean']['output'];
  price: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  testimonials: Array<ProgramTestimonial>;
  timeCommitment: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalParticipants: Scalars['String']['output'];
};

export type ProgramTestimonial = {
  __typename?: 'ProgramTestimonial';
  content: Scalars['String']['output'];
  profile: Profile;
};

export type Programs = {
  __typename?: 'Programs';
  all: ProgramsList;
  available: ProgramsList;
  enrolled: ProgramsList;
  program: Program;
};


export type ProgramsProgramArgs = {
  identifier: Scalars['ID']['input'];
};

export type ProgramsList = {
  __typename?: 'ProgramsList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<Program>;
  nextItem?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ProgressLiveSession = {
  __typename?: 'ProgressLiveSession';
  attended: Scalars['Int']['output'];
  endDatetime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPast: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nonAttendees: Array<NonCompleter>;
  percentage: Scalars['Float']['output'];
  startDatetime: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ProgressReport = {
  __typename?: 'ProgressReport';
  cohortComplete: Scalars['Boolean']['output'];
  cohortName: Scalars['String']['output'];
  liveSessions: Array<ProgressLiveSession>;
  onTrackMetrics: OnTrackMetrics;
  programCompletion: ProgramCompletion;
  topLearners: TopLearners;
  week5Celebration?: Maybe<Week5Celebration>;
  weeklyCompletion: Array<WeeklyCompletionPoint>;
};


export type ProgressReportWeeklyCompletionArgs = {
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgressReportUseCasesDemosSummaries = {
  __typename?: 'ProgressReportUseCasesDemosSummaries';
  demoThemeDetails: Array<ThemeDetail>;
  demoThemes: Array<ThemeSlice>;
  useCaseThemeDetails: Array<ThemeDetail>;
  useCaseThemes: Array<ThemeSlice>;
};

export enum PromptLibraryFilterSort {
  Score = 'SCORE'
}

export type PublicHighlight = {
  __typename?: 'PublicHighlight';
  authorName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  resource: ResourcePublic;
  text?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  aiSandboxThread: AiSandboxThread;
  aiTranslateLanguages: Array<Scalars['String']['output']>;
  aiUsage: AiUsage;
  config: Config;
  currentUser?: Maybe<CurrentUser>;
  /** @deprecated No longer supported */
  dashboardLearningStats: LearningStats;
  defaultPlatformSpace: Mindspace;
  flow: Flow;
  fullFlow: FullFlow;
  getAllResources?: Maybe<GetAllResourcesResponse>;
  getAnnouncements?: Maybe<GetAnnouncementsResponse>;
  getApiKey?: Maybe<Scalars['String']['output']>;
  getArchivedResources?: Maybe<GetArchivedResourcesResponse>;
  getArticleForURL?: Maybe<Resource>;
  getInboxResources?: Maybe<GetInboxResourcesResponse>;
  /** @deprecated No longer supported */
  getInvite?: Maybe<InviteLegacy>;
  getInvitePreviewResources: Array<Maybe<Resource>>;
  /** @deprecated No longer supported */
  getLibraries?: Maybe<GetLibrariesResponse>;
  /** @deprecated No longer supported */
  getLibrary: Library;
  getLibraryResources?: Maybe<GetLibraryResourcesResponse>;
  /** @deprecated No longer supported */
  getLibraryUsers?: Maybe<GetLibraryUsersResponse>;
  /** @deprecated No longer supported */
  getNotifications?: Maybe<GetNotificationsResponse>;
  getPreferences?: Maybe<Preferences>;
  getPublicHighlightByID?: Maybe<PublicHighlight>;
  getSharedHighlight: SharedHighlight;
  getUniqueForwardEmail: Scalars['String']['output'];
  getUnsplashImage: UnsplashImageResponse;
  getUrgentResources?: Maybe<GetUrgentResourcesResponse>;
  getUserTags?: Maybe<GetUserTagsResponse>;
  goalSettings: GoalSettings;
  invite: Invite;
  isMindspaceUniqueNameValid: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  launchpad: Launchpad;
  learningObjective?: Maybe<LearningObjective>;
  /** @deprecated No longer supported */
  libraries?: Maybe<LibrariesResponse>;
  me?: Maybe<User>;
  mindspace: Mindspace;
  mindspaces: Mindspaces;
  myProfile?: Maybe<Profile>;
  nextResource?: Maybe<Resource>;
  notifications?: Maybe<NotificationsPage>;
  /** @deprecated No longer supported */
  pastLearningStats: LearningStats;
  profile?: Maybe<Profile>;
  profileByID?: Maybe<Profile>;
  readResource: Resource;
  readResourceMetadata: ResourceMetadata;
  readUserReadingProgress: UserReadingProgress;
  resources: ListResourcesResponse;
  scrapingRules: Array<Maybe<Rule>>;
  /** @deprecated No longer supported */
  searchLibraryUsers?: Maybe<SearchLibraryUsersResponse>;
  service: Service;
  shouldShowWeeklyLearningStats: Scalars['Boolean']['output'];
  suggestedLearningObjectives?: Maybe<Array<LearningObjective>>;
  teapotByID?: Maybe<Teapot>;
  tools: Array<Tool>;
  weeklyLearningStatsScreen: WeeklyLearningStatsScreen;
};


export type QueryAiSandboxThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFullFlowArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetAllResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  readOnly?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceID?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetArchivedResourcesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  readingTimeRange?: InputMaybe<Scalars['String']['input']>;
  rss?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetArticleForUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryGetInboxResourcesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  readingTimeRange?: InputMaybe<Scalars['String']['input']>;
  rss?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetInviteArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetInvitePreviewResourcesArgs = {
  inviteCode: Scalars['String']['input'];
};


export type QueryGetLibraryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetLibraryResourcesArgs = {
  libraryId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  readingTimeRange?: InputMaybe<Scalars['String']['input']>;
  rss?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetLibraryUsersArgs = {
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryGetNotificationsArgs = {
  from: Scalars['String']['input'];
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPublicHighlightByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSharedHighlightArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUnsplashImageArgs = {
  searchTerm: Scalars['String']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUrgentResourcesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Scalars['String']['input']>;
  readingTimeRange?: InputMaybe<Scalars['String']['input']>;
  rss?: InputMaybe<Scalars['String']['input']>;
  searchTerm: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInviteArgs = {
  code: Scalars['String']['input'];
};


export type QueryIsMindspaceUniqueNameValidArgs = {
  uniqueName: Scalars['String']['input'];
};


export type QueryMindspaceArgs = {
  identifier: Scalars['String']['input'];
};


export type QueryNextResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationsArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfileArgs = {
  username: Scalars['String']['input'];
};


export type QueryProfileByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReadResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReadResourceMetadataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResourcesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
};


export type QueryScrapingRulesArgs = {
  domain: Scalars['String']['input'];
};


export type QuerySearchLibraryUsersArgs = {
  expiredOnly: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  role?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm: Scalars['String']['input'];
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTeapotByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Referrals = {
  __typename?: 'Referrals';
  referralCode: Scalars['String']['output'];
};

export type RelatedTag = {
  __typename?: 'RelatedTag';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RenameLibraryInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RenameResourceInput = {
  headline: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type ReportResourceInput = {
  details: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type ResendExpiredResponse = {
  __typename?: 'ResendExpiredResponse';
  count: Scalars['Int']['output'];
};

export type ResentExpiredInvitesInput = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type Resource = {
  __typename?: 'Resource';
  annotations: Annotations;
  author?: Maybe<Scalars['String']['output']>;
  canAddToMindspace: Scalars['Boolean']['output'];
  canAddToMindstream: Scalars['Boolean']['output'];
  canArchive: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  canMoveToInbox: Scalars['Boolean']['output'];
  canMoveToWorkspace: Scalars['Boolean']['output'];
  canRemove: Scalars['Boolean']['output'];
  canShare: Scalars['Boolean']['output'];
  caption?: Maybe<Caption>;
  comments: Array<Maybe<Comment>>;
  counters?: Maybe<Counters>;
  dateFollowed?: Maybe<Scalars['String']['output']>;
  editorContent?: Maybe<Scalars['String']['output']>;
  evidencing: ResourceEvidencing;
  excerpt?: Maybe<Scalars['String']['output']>;
  extensions: Array<Extension>;
  fileID?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  following: Scalars['Boolean']['output'];
  headline: Scalars['String']['output'];
  highlighters: Highlighters;
  highlightersArray: Array<Highlighter>;
  highlights: Array<Maybe<Highlight>>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images: ResourceImages;
  isInMindstream: Scalars['Boolean']['output'];
  isLastVersion: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  keyTakeaways: Scalars['String']['output'];
  /** @deprecated No longer supported */
  library?: Maybe<Library>;
  /** @deprecated No longer supported */
  libraryId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<ResourceLocation>;
  mainImage: Scalars['String']['output'];
  mindspaceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  owner?: Maybe<User>;
  ownerProfile?: Maybe<Profile>;
  prioritisationScore: Scalars['Int']['output'];
  private?: Maybe<Scalars['Boolean']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  publishedUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  readingTime: Scalars['String']['output'];
  relatedId?: Maybe<Scalars['String']['output']>;
  rss?: Maybe<Scalars['String']['output']>;
  shareReason?: Maybe<Scalars['String']['output']>;
  siteDomain?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  suggested?: Maybe<Scalars['Boolean']['output']>;
  summary: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  textContent?: Maybe<Scalars['String']['output']>;
  textToSpeech?: Maybe<TextToSpeech>;
  trivia?: Maybe<ResourceTrivia>;
  type: Scalars['String']['output'];
  unsubscribed: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userContext?: Maybe<UserContext>;
  userProgress: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type ResourceComment = AnnotationComment & {
  __typename?: 'ResourceComment';
  canEdit: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  profile: Profile;
  resource: Resource;
};

export type ResourceEvidencing = {
  __typename?: 'ResourceEvidencing';
  passiveDetails: Array<EvidencingPassiveDetails>;
  score: ResourceScore;
  state: ResourceEvidencingState;
  totalEarnablePoints: Scalars['Float']['output'];
  totalEarnedPoints: Scalars['Float']['output'];
  totalPassiveEarnablePoints: Scalars['Float']['output'];
  totalPassiveEarnedPoints: Scalars['Float']['output'];
  totalTriviaEarnablePoints: Scalars['Float']['output'];
  totalTriviaEarnedPoints: Scalars['Float']['output'];
  triviaDetails: Array<EvidencingTriviaDetails>;
};

export enum ResourceEvidencingState {
  NoData = 'NO_DATA',
  Ok = 'OK'
}

export type ResourceImages = {
  __typename?: 'ResourceImages';
  main: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
};

export type ResourceLocation = InLibrary | Mindspace;

export type ResourceMetadata = {
  __typename?: 'ResourceMetadata';
  excerpt?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mainImage: Scalars['String']['output'];
  publishedDate?: Maybe<Scalars['String']['output']>;
  readingTime: Scalars['String']['output'];
  state: Scalars['String']['output'];
  textContent: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ResourcePublic = {
  __typename?: 'ResourcePublic';
  author?: Maybe<Scalars['String']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedDate?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ResourceReadingProgress = {
  lastIndexID: Scalars['Int']['input'];
  lastTimestamp?: InputMaybe<Scalars['Int']['input']>;
  percent: Scalars['Float']['input'];
};

export type ResourceScore = {
  __typename?: 'ResourceScore';
  details: Array<ResourceScoreDetails>;
  total: Scalars['Float']['output'];
};

export type ResourceScoreDetails = {
  __typename?: 'ResourceScoreDetails';
  component: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ResourceTrivia = {
  __typename?: 'ResourceTrivia';
  earnablePoints: Scalars['Float']['output'];
  questions: Array<ResourceTriviaQuestion>;
  skillsTested: Array<Skill>;
};

export type ResourceTriviaAnswer = {
  __typename?: 'ResourceTriviaAnswer';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ResourceTriviaFreetext = {
  __typename?: 'ResourceTriviaFreetext';
  earnablePoints: Scalars['Float']['output'];
  question?: Maybe<ResourceTriviaFreetextQuestion>;
  skillsTested: Array<Skill>;
};

export type ResourceTriviaFreetextQuestion = {
  __typename?: 'ResourceTriviaFreetextQuestion';
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  timeInSeconds: Scalars['Int']['output'];
  userResult?: Maybe<TriviaFreetextResult>;
};

export type ResourceTriviaMultipleChoiceQuestion = {
  __typename?: 'ResourceTriviaMultipleChoiceQuestion';
  answers: Array<ResourceTriviaAnswer>;
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  timeInSeconds: Scalars['Int']['output'];
  userResult?: Maybe<TriviaResult>;
};

export type ResourceTriviaQuestion = ResourceTriviaMultipleChoiceQuestion;

export type RudderstackConfig = {
  __typename?: 'RudderstackConfig';
  url: Scalars['String']['output'];
  writeKey: Scalars['String']['output'];
};

export type Rule = {
  __typename?: 'Rule';
  author?: Maybe<Array<Scalars['String']['output']>>;
  content?: Maybe<Array<Scalars['String']['output']>>;
  content_clean?: Maybe<Array<Scalars['String']['output']>>;
  date_published?: Maybe<Array<Scalars['String']['output']>>;
  domain: Scalars['String']['output'];
  image?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Array<Scalars['String']['output']>>;
};

export type RuleInput = {
  author?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  content_clean?: InputMaybe<Array<Scalars['String']['input']>>;
  date_published?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  image?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SandboxHistoryItem = {
  __typename?: 'SandboxHistoryItem';
  name: Scalars['String']['output'];
  threadID: Scalars['ID']['output'];
};

export type SearchLibraryUsersResponse = {
  __typename?: 'SearchLibraryUsersResponse';
  count: Scalars['Int']['output'];
  nextItem: Scalars['Int']['output'];
  users: Array<Maybe<UserInLibrary>>;
};

export type SearchMyCommentsResponse = {
  __typename?: 'SearchMyCommentsResponse';
  comments: Array<Maybe<Comment>>;
  count: Scalars['Int']['output'];
  nextItem: Scalars['Int']['output'];
};

export type SearchMyHighlightsResponse = {
  __typename?: 'SearchMyHighlightsResponse';
  count: Scalars['Int']['output'];
  highlights: Array<Maybe<Highlight>>;
  nextItem: Scalars['Int']['output'];
};

export type SearchResourceResponse = {
  __typename?: 'SearchResourceResponse';
  nextItem: Scalars['Int']['output'];
  readingTime: Scalars['Float']['output'];
  relatedTags?: Maybe<Array<Maybe<RelatedTag>>>;
  resources: Array<Maybe<Resource>>;
  totalHits: Scalars['Int']['output'];
};

export type Section = {
  __typename?: 'Section';
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  item: SectionItem;
  items: Array<SectionItem>;
  progressPercent?: Maybe<Scalars['Int']['output']>;
  shortDescription: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SectionItemArgs = {
  id: Scalars['ID']['input'];
};

export type SectionItem = {
  __typename?: 'SectionItem';
  content?: Maybe<SectionItemContent>;
  doneTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: SectionItemMetadata;
  state: SectionItemStates;
};

export type SectionItemContent = SectionItemContentDemoSubmission | SectionItemContentLiveSession | SectionItemContentPersonalizer | SectionItemContentResource;

export type SectionItemContentDemoSubmission = {
  __typename?: 'SectionItemContentDemoSubmission';
  createdAt: Scalars['String']['output'];
  dayId: Scalars['ID']['output'];
  demoType: DemoType;
  description: Scalars['String']['output'];
  hasCurrentUserVoted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  recordingFileId?: Maybe<Scalars['ID']['output']>;
  recordingFileUrl?: Maybe<Scalars['String']['output']>;
  submitter: DemoSubmitter;
  title: Scalars['String']['output'];
  voteCount: Scalars['Int']['output'];
};


export type SectionItemContentDemoSubmissionHasCurrentUserVotedArgs = {
  cohortId: Scalars['ID']['input'];
  mindspaceId: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
};

export type SectionItemContentLiveSession = {
  __typename?: 'SectionItemContentLiveSession';
  event: MindspaceEvent;
  id: Scalars['ID']['output'];
  resource?: Maybe<Resource>;
};

export type SectionItemContentPersonalizer = {
  __typename?: 'SectionItemContentPersonalizer';
  id: Scalars['ID']['output'];
};

export type SectionItemContentResource = {
  __typename?: 'SectionItemContentResource';
  id: Scalars['ID']['output'];
  introduction: Scalars['String']['output'];
  introductionCallout?: Maybe<Scalars['String']['output']>;
  learningTasks: Array<LearningTask>;
  references: Array<Resource>;
  resource?: Maybe<Resource>;
  resourceID?: Maybe<Scalars['String']['output']>;
  sandboxApplicable: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
  summaryCallout?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trivia?: Maybe<ResourceTrivia>;
  triviaFreetext?: Maybe<ResourceTriviaFreetext>;
};

export type SectionItemMetadata = {
  __typename?: 'SectionItemMetadata';
  date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  sectionID: Scalars['String']['output'];
  sectionTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum SectionItemStates {
  Done = 'done',
  NotDone = 'notDone',
  Unavailable = 'unavailable'
}

export type SendCohortEmailResponse = {
  __typename?: 'SendCohortEmailResponse';
  failedEmails: Array<Scalars['String']['output']>;
  sentCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Service = {
  __typename?: 'Service';
  name: Scalars['String']['output'];
  schema: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type SetPreferencesInput = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type SetResourceFolderInput = {
  folder: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type SetResourcePrivacyInput = {
  id: Scalars['ID']['input'];
  private: Scalars['Boolean']['input'];
};

export type SetResourcesFolderInput = {
  folder: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type SharedHighlight = {
  __typename?: 'SharedHighlight';
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SignupInput = {
  email: Scalars['String']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmParams>;
};

export type SignupResponse = {
  __typename?: 'SignupResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type Skill = {
  __typename?: 'Skill';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  skillGroup: SkillGroup;
  skillGroupID: Scalars['ID']['output'];
  topSkillGroup: SkillGroup;
};

export type SkillGroup = {
  __typename?: 'SkillGroup';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<SkillGroup>;
  parentID: Scalars['ID']['output'];
};

export type SkillGroupPoints = {
  __typename?: 'SkillGroupPoints';
  points: Scalars['Float']['output'];
  skillGroup: SkillGroup;
};

export type SkillPoints = {
  __typename?: 'SkillPoints';
  points: Scalars['Float']['output'];
  skill: Skill;
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sponsor = {
  __typename?: 'Sponsor';
  id: Scalars['ID']['output'];
  logourl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StateStore = {
  __typename?: 'StateStore';
  aiUsageLastDismissedAt?: Maybe<Scalars['String']['output']>;
  extensionPromoLastDismissedAt?: Maybe<Scalars['String']['output']>;
  programSwitchSeen: Scalars['Boolean']['output'];
  subscriptionHomeSeen: Scalars['Boolean']['output'];
  subscriptionUpgradeSeen: Scalars['Boolean']['output'];
};

export type StreakPerDay = {
  __typename?: 'StreakPerDay';
  completed: Scalars['Boolean']['output'];
  dayOfWeek: Scalars['Int']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  aiDelta: AiDeltaResponse;
  aiFeedback: AiFeedbackResponse;
  aiWebExtensionFeedback: AiFeedbackResponse;
  articlePointsUpdated?: Maybe<ResourceEvidencing>;
  commentAdded: ResourceComment;
  commentRemoved: ResourceComment;
  completeLearningTaskSandboxFeedback: LearningTaskSandboxFeedback;
  currentTime: Scalars['String']['output'];
  highlightAdded: AnnotationHighlight;
  highlightRemoved: AnnotationHighlight;
  highlightUpdated: AnnotationHighlight;
  notificationAdded: Notification;
  personalizationStatus: PersonalizationUpdate;
  pointsEarned: EvidencePointsEarned;
  resourceUpdated: Resource;
};


export type SubscriptionAiDeltaArgs = {
  idempotencyID: Scalars['ID']['input'];
};


export type SubscriptionAiFeedbackArgs = {
  idempotencyID: Scalars['ID']['input'];
};


export type SubscriptionAiWebExtensionFeedbackArgs = {
  idempotencyID: Scalars['ID']['input'];
};


export type SubscriptionArticlePointsUpdatedArgs = {
  articleID?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionCommentAddedArgs = {
  articleID: Scalars['ID']['input'];
};


export type SubscriptionCommentRemovedArgs = {
  articleID: Scalars['ID']['input'];
};


export type SubscriptionCompleteLearningTaskSandboxFeedbackArgs = {
  idempotencyID: Scalars['String']['input'];
};


export type SubscriptionHighlightAddedArgs = {
  articleID: Scalars['ID']['input'];
};


export type SubscriptionHighlightRemovedArgs = {
  articleID: Scalars['ID']['input'];
};


export type SubscriptionHighlightUpdatedArgs = {
  articleID: Scalars['ID']['input'];
};


export type SubscriptionPersonalizationStatusArgs = {
  idempotencyID: Scalars['ID']['input'];
};


export type SubscriptionResourceUpdatedArgs = {
  id: Scalars['ID']['input'];
};

export type SurveyResponse = {
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
};

export enum SurveyType {
  End = 'END',
  Start = 'START'
}

export type Tag = {
  __typename?: 'Tag';
  name: Scalars['String']['output'];
};

export type Teapot = {
  __typename?: 'Teapot';
  id: Scalars['ID']['output'];
  world: Scalars['String']['output'];
  worldDeferred: TeapotWorld;
};

export type TeapotWorld = {
  __typename?: 'TeapotWorld';
  world: Scalars['String']['output'];
};

export type TextToSpeech = {
  __typename?: 'TextToSpeech';
  fileUrl?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

export type ThemeDetail = {
  __typename?: 'ThemeDetail';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ThemeSlice = {
  __typename?: 'ThemeSlice';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  theme: Scalars['String']['output'];
};

export enum TimeEntryType {
  Platform = 'PLATFORM',
  Survey = 'SURVEY'
}

export type TimeOfDay = {
  __typename?: 'TimeOfDay';
  hour: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
};

export type Tool = {
  __typename?: 'Tool';
  description: Scalars['String']['output'];
  descriptionLong: Scalars['String']['output'];
  discountCode?: Maybe<Scalars['String']['output']>;
  discountDescription?: Maybe<Scalars['String']['output']>;
  discountUrl?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TopLearnerEp = {
  __typename?: 'TopLearnerEP';
  eps: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  profilePictureURL?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type TopLearnerPrompt = {
  __typename?: 'TopLearnerPrompt';
  name: Scalars['String']['output'];
  profilePictureURL?: Maybe<Scalars['String']['output']>;
  prompts: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type TopLearners = {
  __typename?: 'TopLearners';
  mostEPs: Array<TopLearnerEp>;
  mostPrompts: Array<TopLearnerPrompt>;
};

export type TriviaExtension = Extension & {
  __typename?: 'TriviaExtension';
  afterBlockIndex: Scalars['Int']['output'];
  earnablePoints: Scalars['Float']['output'];
  earnedPoints: Scalars['Float']['output'];
  question: ResourceTriviaQuestion;
  result?: Maybe<TriviaResult>;
};

export type TriviaFreetextResult = {
  __typename?: 'TriviaFreetextResult';
  answer: Scalars['String']['output'];
  earnedTriviaPoints: Scalars['Float']['output'];
  feedback: Scalars['String']['output'];
};

export type TriviaMultipleChoiceResult = {
  __typename?: 'TriviaMultipleChoiceResult';
  answer: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUserAnswer: Scalars['Boolean']['output'];
  result: TriviaResultEnum;
};

export type TriviaResult = {
  __typename?: 'TriviaResult';
  answers: Array<TriviaResultAnswer>;
  earnedTriviaPoints: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  perObjective: Array<TriviaResultObjective>;
  question: Scalars['String']['output'];
  result: TriviaResultEnum;
};

export type TriviaResultAnswer = TriviaMultipleChoiceResult;

export enum TriviaResultEnum {
  Almost = 'ALMOST',
  Correct = 'CORRECT',
  Timeout = 'TIMEOUT',
  Wrong = 'WRONG'
}

export type TriviaResultObjective = {
  __typename?: 'TriviaResultObjective';
  objective: LearningObjective;
  pointsEarned: Scalars['Float']['output'];
};

export type UtmParams = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UnsplashImageResponse = {
  __typename?: 'UnsplashImageResponse';
  url: Scalars['String']['output'];
};

export type UpdateLibraryHighlightersInput = {
  highlighters: LibraryHighlightersInput;
  id: Scalars['ID']['input'];
};

export type UpdateLibraryPreferencesInput = {
  notificationArticleAddedToSharedLibrary: Scalars['Boolean']['input'];
  notificationUserJoinedLibrary: Scalars['Boolean']['input'];
  subscribeToNewArticles: Scalars['Boolean']['input'];
};

export type UpdateResourceHighlightersInput = {
  highlighters: HighlightersInput;
  id: Scalars['ID']['input'];
};

export type UpdateResourceTagsInput = {
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type UpdateResourceUserProgressInput = {
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type UseCase = {
  __typename?: 'UseCase';
  completedAt?: Maybe<Scalars['String']['output']>;
  completionExplanation?: Maybe<Scalars['String']['output']>;
  completionFileIDs?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  difficulty: UseCaseDifficulty;
  earnedPoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  steps: Array<UseCaseStep>;
  title: Scalars['String']['output'];
  userID: Scalars['String']['output'];
};

export type UseCaseCompletionResponse = {
  __typename?: 'UseCaseCompletionResponse';
  earnedPoints?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum UseCaseDifficulty {
  Advanced = 'ADVANCED',
  Easy = 'EASY',
  Moderate = 'MODERATE'
}

export type UseCaseList = {
  __typename?: 'UseCaseList';
  hasMore: Scalars['Boolean']['output'];
  items: Array<UseCase>;
  totalCount: Scalars['Int']['output'];
};

export type UseCaseStep = {
  __typename?: 'UseCaseStep';
  createdAt?: Maybe<Scalars['String']['output']>;
  stepDescription: Scalars['String']['output'];
  stepId: Scalars['ID']['output'];
  stepNumber: Scalars['Int']['output'];
  stepTitle: Scalars['String']['output'];
  tools: Array<Maybe<Tool>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  /** @deprecated No longer supported */
  activatedAt: Scalars['Int']['output'];
  /** @deprecated No longer supported */
  blocked: Scalars['Boolean']['output'];
  company?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  /** @deprecated No longer supported */
  hasAddedResources: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isStaff: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  onboarded: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  pmfSurveyFilled: Scalars['Boolean']['output'];
  preferences?: Maybe<Preferences>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  score: Scalars['Int']['output'];
  signupDate: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  store?: Maybe<StateStore>;
  /** @deprecated No longer supported */
  surveyFilled: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type UserBilling = {
  __typename?: 'UserBilling';
  autoRenewal: Scalars['Boolean']['output'];
  billingPortalUrl: Scalars['String']['output'];
  billingUser?: Maybe<BillingUser>;
  cancellationDate: Scalars['String']['output'];
  cohort?: Maybe<Cohort>;
  expirationDate: Scalars['String']['output'];
  mindspace?: Maybe<Mindspace>;
  purchaseDate: Scalars['String']['output'];
  recurrence: BillingRecurrence;
  renewalDate: Scalars['String']['output'];
  status: UserBillingStatus;
};

export enum UserBillingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED'
}

export type UserContext = {
  __typename?: 'UserContext';
  userProgress: UserProgress;
};

export type UserInLibrary = {
  __typename?: 'UserInLibrary';
  email?: Maybe<Scalars['String']['output']>;
  inviteExpiry?: Maybe<Scalars['Time']['output']>;
  profile?: Maybe<Profile>;
  role?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type UserProgress = {
  __typename?: 'UserProgress';
  lastIndexID: Scalars['Int']['output'];
  lastTimestamp: Scalars['Int']['output'];
  percent: Scalars['Float']['output'];
};

export type UserReadingProgress = {
  __typename?: 'UserReadingProgress';
  bestStreak: Scalars['Int']['output'];
  goalMinutes: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  streak: Scalars['Int']['output'];
  streaksPerDay: Array<StreakPerDay>;
  timeOfDay: Scalars['String']['output'];
  totalDays: Scalars['Int']['output'];
};

export type Week5Celebration = {
  __typename?: 'Week5Celebration';
  averageConfidenceEnd: Scalars['Float']['output'];
  averageConfidenceStart: Scalars['Float']['output'];
  averageTimeSaved: Scalars['Float']['output'];
  averageUsageEnd: Scalars['Float']['output'];
  averageUsageStart: Scalars['Float']['output'];
};

export type WeeklyCompletionPoint = {
  __typename?: 'WeeklyCompletionPoint';
  completed: Scalars['Int']['output'];
  nonCompleters: Array<NonCompleter>;
  percentage: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  week: Scalars['Int']['output'];
};

export type WeeklyGuidance = {
  __typename?: 'WeeklyGuidance';
  availableWeeks: Array<WeeklyGuidance>;
  dailyTasks: Array<WeeklyGuidanceDailyTask>;
  hasAssessment: Scalars['Boolean']['output'];
  learningObjective: LearningObjective;
  nextAvailable: Scalars['Boolean']['output'];
  phaseNumber: Scalars['Int']['output'];
  previousAvailable: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  totalWeeks: Scalars['Int']['output'];
  weekNumber: Scalars['Int']['output'];
};

export type WeeklyGuidanceDailyTask = {
  __typename?: 'WeeklyGuidanceDailyTask';
  dayNumber: Scalars['Int']['output'];
  introduction: Scalars['String']['output'];
  introductionCallout?: Maybe<Scalars['String']['output']>;
  isToday: Scalars['Boolean']['output'];
  resource?: Maybe<Resource>;
  state: WeeklyGuidanceDailyTaskState;
  summary: Scalars['String']['output'];
  summaryCallout?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trivia?: Maybe<ResourceTrivia>;
  triviaFreetext?: Maybe<ResourceTriviaFreetext>;
};

export enum WeeklyGuidanceDailyTaskState {
  Done = 'done',
  NotDone = 'notDone',
  Unavailable = 'unavailable'
}

export type AiAskResponse = {
  __typename?: 'aiAskResponse';
  messages: Array<AiMessage>;
  threadID?: Maybe<Scalars['ID']['output']>;
};

export type AiAssessmentResponse = {
  __typename?: 'aiAssessmentResponse';
  average?: Maybe<Scalars['Float']['output']>;
  message: AiMessage;
  passed?: Maybe<Scalars['Boolean']['output']>;
  scores?: Maybe<Array<Scalars['Int']['output']>>;
  threadID: Scalars['ID']['output'];
};

export type AiContext = {
  articleID?: InputMaybe<Scalars['ID']['input']>;
  cohortID?: InputMaybe<Scalars['ID']['input']>;
  dayID?: InputMaybe<Scalars['ID']['input']>;
  messages?: InputMaybe<Array<AiMessageInput>>;
  mindspaceID: Scalars['ID']['input'];
  programID?: InputMaybe<Scalars['ID']['input']>;
  selection?: InputMaybe<Scalars['String']['input']>;
  threadID?: InputMaybe<Scalars['ID']['input']>;
  useCaseID?: InputMaybe<Scalars['ID']['input']>;
};

export type AiDeltaResponse = {
  __typename?: 'aiDeltaResponse';
  message: AiMessage;
  threadID?: Maybe<Scalars['ID']['output']>;
};

export type AiFeedback = {
  __typename?: 'aiFeedback';
  values?: Maybe<AiFeedbackVal>;
};

export type AiFeedbackResponse = {
  __typename?: 'aiFeedbackResponse';
  error?: Maybe<Scalars['Boolean']['output']>;
  feedback?: Maybe<AiFeedback>;
  message: AiMessage;
  threadID?: Maybe<Scalars['ID']['output']>;
};

export type AiFeedbackScore = {
  __typename?: 'aiFeedbackScore';
  category?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type AiFeedbackVal = {
  __typename?: 'aiFeedbackVal';
  scores: Array<AiFeedbackScore>;
  suggestion: Scalars['String']['output'];
};

export type AiMessage = {
  __typename?: 'aiMessage';
  ID?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  role: AiMessageRole;
};

export type AiMessageInput = {
  content: Scalars['String']['input'];
  role: AiMessageRole;
};

export enum AiMessageRole {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

export type AiSandboxHistory = {
  __typename?: 'aiSandboxHistory';
  list?: Maybe<ListSandboxHistory>;
};


export type AiSandboxHistoryListArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type AiSandboxResponse = {
  __typename?: 'aiSandboxResponse';
  messages: Array<AiMessage>;
  threadID: Scalars['ID']['output'];
};

export type AiSandboxThread = {
  __typename?: 'aiSandboxThread';
  messages: Array<AiMessage>;
  threadID: Scalars['ID']['output'];
};

export type AiWebExtensionContext = {
  messages?: InputMaybe<Array<AiMessageInput>>;
  threadID?: InputMaybe<Scalars['ID']['input']>;
};

export type AiWebExtensionResponse = {
  __typename?: 'aiWebExtensionResponse';
  messages: Array<AiMessage>;
  threadID: Scalars['ID']['output'];
};

export type AiWebSearchImage = {
  __typename?: 'aiWebSearchImage';
  source?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AiWebSearchResponse = {
  __typename?: 'aiWebSearchResponse';
  ID?: Maybe<Scalars['ID']['output']>;
  citations?: Maybe<Array<Scalars['String']['output']>>;
  images?: Maybe<Array<AiWebSearchImage>>;
  messages: Array<AiMessage>;
  relatedQuestions?: Maybe<Array<Scalars['String']['output']>>;
};

export type PersonalizerContext = {
  messages?: InputMaybe<Array<AiMessageInput>>;
  mindspaceID: Scalars['ID']['input'];
  threadID?: InputMaybe<Scalars['ID']['input']>;
};

export type SavePromptResponse = {
  __typename?: 'savePromptResponse';
  shareID: Scalars['ID']['output'];
};

export type WeeklyLearningStatsScreen = {
  __typename?: 'weeklyLearningStatsScreen';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MindstoneConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type MindstoneConfigQuery = { __typename?: 'Query', config: { __typename?: 'Config', siteURL: string, api: string, appUrl: string, identityUrl: string, environment: Environment, growthbookKey: string, googleMapKey: string, rudderstack?: { __typename?: 'RudderstackConfig', url: string, writeKey: string } | null, oauth?: { __typename?: 'OAuthConfig', apple: string, google: string, linkedIn: string, microsoft: string, microsoftClientId: string } | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResponse', refreshToken: string, accessToken: string } | null };

export type ForgotPasswordWithPinMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordWithPinMutation = { __typename?: 'Mutation', forgotPasswordWithPin: boolean };

export type ResetPasswordWithPinMutationVariables = Exact<{
  email: Scalars['String']['input'];
  pin: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordWithPinMutation = { __typename?: 'Mutation', resetPasswordWithPin: boolean };

export type ValidateForgotPasswordPinMutationVariables = Exact<{
  email: Scalars['String']['input'];
  pin: Scalars['String']['input'];
}>;


export type ValidateForgotPasswordPinMutation = { __typename?: 'Mutation', validateForgotPasswordPin: boolean };

export type RequestLoginPinMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestLoginPinMutation = { __typename?: 'Mutation', requestLoginPin: boolean };

export type LoginWithPinMutationVariables = Exact<{
  email: Scalars['String']['input'];
  pin: Scalars['String']['input'];
}>;


export type LoginWithPinMutation = { __typename?: 'Mutation', loginWithPin: { __typename?: 'LoginResponse', refreshToken: string, accessToken: string } };

export type UpdateProfileMutationVariables = Exact<{
  username: Scalars['String']['input'];
  profile: ProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateUsername: boolean, updateProfile?: { __typename?: 'Profile', id: string } | null };

export type CurrentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentProfileQuery = { __typename?: 'Query', myProfile?: { __typename?: 'Profile', username: string, firstName?: string | null, lastName?: string | null, company?: string | null, position?: string | null } | null };

export type SignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmParams>;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'SignupResponse', refreshToken: string, accessToken: string } };

export type RefreshAccessTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshToken: string };

export type AuthenticateMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  authCode: Scalars['String']['input'];
  utm?: InputMaybe<UtmParams>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate?: { __typename?: 'AuthenticateResponse', refreshToken: string, accessToken: string, newUser: boolean } | null };


export const MindstoneConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MindstoneConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteURL"}},{"kind":"Field","name":{"kind":"Name","value":"api"}},{"kind":"Field","name":{"kind":"Name","value":"appUrl"}},{"kind":"Field","name":{"kind":"Name","value":"identityUrl"}},{"kind":"Field","name":{"kind":"Name","value":"rudderstack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"writeKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oauth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apple"}},{"kind":"Field","name":{"kind":"Name","value":"google"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"microsoft"}},{"kind":"Field","name":{"kind":"Name","value":"microsoftClientId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"growthbookKey"}},{"kind":"Field","name":{"kind":"Name","value":"googleMapKey"}}]}}]}}]} as unknown as DocumentNode<MindstoneConfigQuery, MindstoneConfigQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"body"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"inviteCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const ForgotPasswordWithPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"forgotPasswordWithPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forgotPasswordWithPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ForgotPasswordWithPinMutation, ForgotPasswordWithPinMutationVariables>;
export const ResetPasswordWithPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resetPasswordWithPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPasswordWithPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"pin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pin"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordWithPinMutation, ResetPasswordWithPinMutationVariables>;
export const ValidateForgotPasswordPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"validateForgotPasswordPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateForgotPasswordPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"pin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pin"}}}]}]}}]} as unknown as DocumentNode<ValidateForgotPasswordPinMutation, ValidateForgotPasswordPinMutationVariables>;
export const RequestLoginPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requestLoginPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestLoginPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<RequestLoginPinMutation, RequestLoginPinMutationVariables>;
export const LoginWithPinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"loginWithPin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithPin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"pin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<LoginWithPinMutation, LoginWithPinMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"username"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUsername"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"username"},"value":{"kind":"Variable","name":{"kind":"Name","value":"username"}}}]},{"kind":"Field","name":{"kind":"Name","value":"updateProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const CurrentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]} as unknown as DocumentNode<CurrentProfileQuery, CurrentProfileQueryVariables>;
export const SignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Signup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UTMParams"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"body"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"inviteCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"utm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<SignupMutation, SignupMutationVariables>;
export const RefreshAccessTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshAccessToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}]}]}}]} as unknown as DocumentNode<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const AuthenticateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Authenticate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"utm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UTMParams"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"body"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"authorizationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"utm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"utm"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"inviteCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"newUser"}}]}}]}}]} as unknown as DocumentNode<AuthenticateMutation, AuthenticateMutationVariables>;